import React from 'react';
import {Link} from "react-router-dom";
import {Helper} from "./Helper";
import {DownloadReportModal, Form2FileUpload, Modal} from "react-spaceship-web";
import ProductsStock from "./ProductsStock";
import {AppContext} from "./AppProvider";
import {ProductChartOfAccountManage} from "./ProductChartOfAccount";
import ShipmentProductAudit from "./ShipmentProductAudit";
import FilterGroup from "./FilterGroup";

export default class Products extends React.Component {
	static contextType = AppContext

	constructor(props) {
		super(props);

		let _state = {};
		_state.params = {};
		window.Route.on({
			'/v2/products': () => {
				_state = {
					mode: 'list',
				};
			},
			'/v2/products/new': () => {
				_state = {
					mode: 'create'
				};
			},
			'/v2/products/:product_id': (params) => {
				_state = {
					mode: 'view',
					params: params,
				};
			},
			'/v2/products/:product_id/edit': (params) => {
				_state = {
					mode: 'edit',
					params: params,
				};
			},
		}).match();
		_state.product = false;
		_state.products = [];
		_state.product_price_condition = [];
		_state.is_loading = true;
		_state.qs = window.Global.getAllQueryStrings();
		this.state = _state;
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			window.Route.on({
				'/v2/products': () => {
					this.setState({
						mode: 'list',
						is_loading: true,
						product: false,
						products: [],
						product_price_condition: [],
						qs: window.Global.getAllQueryStrings()
					}, () => {
						this.fetch();
					})
				},
				'/v2/products/new': () => {
					this.setState({
						mode: 'create',
						is_loading: true,
						product: false,
						products: [],
						product_price_condition: [],
						qs: window.Global.getAllQueryStrings()
					}, () => {
						this.create();
					})
				},
				'/v2/products/:product_id': (params) => {
					this.setState({
						mode: 'view',
						is_loading: true,
						product: false,
						params: params,
						products: [],
						product_price_condition: [],
						qs: window.Global.getAllQueryStrings()
					}, () => {
						this.view();
					});
				},
				'/v2/products/:product_id/edit': (params) => {
					this.setState({
						mode: 'edit',
						is_loading: true,
						product: false,
						params: params,
						products: [],
						product_price_condition: [],
						qs: window.Global.getAllQueryStrings()
					}, () => {
						this.edit();
					});
				},
			}).match();
		} else if (this.props.location.search !== prevProps.location.search) {
			this.setState({
				mode: 'list',
				is_loading: true,
				product: false,
				products: [],
				product_price_condition: [],
				qs: window.Global.getAllQueryStrings()
			}, () => {
				this.fetch();
			})
		}
	}

	componentDidMount() {
		if (this.state.mode === 'view') {
			this.view();
		}
		if (this.state.mode === 'list') {
			this.fetch();
		}
		if (this.state.mode === 'edit') {
			this.edit();
		}
		if (this.state.mode === 'create') {
			this.create();
		}
	}


	fetch() {
		let data = window.Global.getAllQueryStrings();
		if (!data.status) {
			data.status = 'active';
		}

		if (this.context.app.user.user_permission.is_role_audit) {
			data.request_data_product_chart_of_account = 1;
		}

		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/product',
			data: data,
			done: (response) => {
				this.setState({
					products: response.product,
					is_loading: false,
				}, () => {
					setTimeout(() => {
						if (response['product_price_unit_name']) {
							window.$.each(response['product_price_unit_name'], (i, product_price_unit_name) => {
								this.$parent.find('form').find('.Explorer[data-explorer_input_name="product_price_unit_name[]"]').explorer('set value', product_price_unit_name);
							})
						}
						if (response.filter_product_category) {
							this.$parent.find('form').find('input[name="filter_product_category_id"]').explorer('set value', response.filter_product_category);
						}
						if (response.filter_product_brand) {
							this.$parent.find('form').find('input[name="filter_product_brand_id"]').explorer('set value', response.filter_product_brand);
						}
						if (response.filter_product) {
							this.$parent.find('form').find('input[name="filter_product_id"]').explorer('set value', response.filter_product);
						}
					})

					this.$parent.find('.Table_root').tablePagination({
						disableContent: true,
						data: response.product,
						count: response.count,
						onClickPagination: (p) => {
							let qs = {...this.state.qs};
							qs.page = p;
							this.props.history.push(window.Global.getQueryStringLinkFromObject(qs));
						}
					})
				})
			},
			fail: () => {

			}
		});
	}

	create() {
		this.setState({
			is_loading: false
		}, () => {

			let $parent = this.$parent;
			let $form = this.$parent.find('form');
			$form.form2('setup');
			this.prepare();
			$form.form2('submit', {
				method: 'POST',
				url: process.env.REACT_APP_DOMAIN + '/api/product',
				beforeSent: function (data) {
					if (data['is_not_count_stock'] !== "0"
						&& data['is_not_count_stock'] !== "1"
					) {
						window.Global.messageTop({
							type: 'negative',
							message: 'เลือกประเภทสินค้า'
						});
						return false;
					}

					window.$('#cancelButton').addClass('loading');
					window.$('#draft-button').addClass('loading');
					return data;
				},
				loadingButton: window.$(this.$parent).find('#submit-button'),
				onSuccess: (response) => {
					window.Global.messageTop({
						type: 'positive',
						message: 'บันทึกข้อมูลสำเร็จ'
					});
					this.props.history.push({
						pathname: '/v2/products/' + response.product_id,
						search: null,
						state: null
					});
				},
				onError: () => {
					window.$('#cancelButton').removeClass('loading');
					window.$('#draft-button').removeClass('loading');
				},
			});
			$parent.find('.red').hide();
			window.GlobalFunc.displayOrNot2($form, [
				{
					attr: 'data-state',
					value: 'create'
				}
			]);

			$parent.find('#draft-button').off('click').on('click', function () {
				$form.find('input[name="is_draft"]').val('1');
				$form.trigger('submit');
			});
			$parent.find('#submit-button').off('click').on('click', function () {
				$form.find('input[name="is_draft"]').val('0');
				$form.trigger('submit');
			});

		})
	}


	edit() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/product',
			data: {
				product_id: this.state.params.product_id,
				request_product_bom_adjustment_cost: true,
				request_initial_stock_location: true,
				request_product_gallery_file_upload: true,
				type: 'stair_step'
			},
			done: (response) => {
				let product = response.product[0] || false;
				this.setState({
					product: product,
					is_loading: false,
				}, () => {
					this.$parent.find('form').form2('setup');
					this.prepare();

					if (this.state.product.default_supplier) {
						this.$parent.find('input[name="default_supplier_id"]').explorer(
							'set value',
							this.state.product.default_supplier
						);
					}

					this.$parent.find('form').form2('submit', {
						method: 'PUT',
						url: process.env.REACT_APP_DOMAIN + '/api/product',
						beforeSent: function (data) {
							if (data['is_not_count_stock'] !== "0"
								&& data['is_not_count_stock'] !== "1"
							) {
								window.Global.messageTop({
									type: 'negative',
									message: 'เลือกประเภทสินค้า'
								});
								return false;
							}
							return data;
						},
						loadingButton: window.$(this.$parent).find('#submit-button'),
						onSuccess: (response) => {
							window.Global.messageTop({
								type: 'positive',
								message: 'บันทึกข้อมูลสำเร็จ'
							});

							this.props.history.push({
								pathname: '/v2/products/' + this.state.product.id,
								search: null,
								state: null
							});
						}
					});
				});
			},
			fail: () => {

			}
		});
	}

	getBomManageNode($parent, product_bom, current_product_id) {
		let $e = window.$(window.Mustache.render('<div class="ProductListBom_item flex row middle-xs">\n    <div class="name flex row middle-xs">\n        <input type="text" name="search_product_name" placeholder="เลือกสินค้า">\n    </div>\n    <div class="quantity field flex row">\n        <input type="text" name="product_amount" placeholder="จำนวน">\n        &nbsp;\n        <div class="ui icon button"><i class="remove icon"></i></div>\n    </div>\n</div>'));
		$parent.append($e);
		$e.find('.button').on('click', function () {
			window.Global.confirm({
				title: 'ต้องการลบหรือไม่ ?',
				content: '<form class="ui form">\n\t<p>โปรดยืนยันลบข้อมูล</p>\n\t<div class="ui error message"></div>\n</form>',
				cancel_text: 'ไม่ดำเนินการ',
				approve_text: 'ลบข้อมูล',
				onApprove: () => {
					$e.remove();
				},
			});
		});

		let onClick = function (product) {
			let $e2 = window.$(window.Mustache.render('<img class="ui avatar image" src="{{product_image_file_upload.url}}">\n<div style="margin: 0 10px; 0 0;">\n    <div class="header">{{name}}</div>\n    <input type="hidden" name="product_bom[][material_product_id]" value="{{id}}">\n</div>', product));
			$e.find('.name').html($e2);

			let $input = window.$(window.Mustache.render('<div class="ui right labeled input right floated" style="width: initial;">\n    <input type="text" name="product_amount" placeholder="จำนวน" value="1" style="max-width: 71px;">\n    <input type="hidden" name="product_bom[][quantity]" value="1">\n    <input type="hidden" name="product_bom[][ratio]" value="1">\n    <div class="ui dropdown label" data-name="unit" data-form2_setup>\n        <div class="text"></div>\n        <i class="dropdown icon"></i>\n        <div class="menu">\n            {{#sell_price}}\n            <div data-ratio="{{ratio}}" data-value="{{ratio}}" class="item">{{unit_name}}</div>\n            {{/sell_price}}\n        </div>\n    </div>\n</div>', product));
			$e.find('*[name="product_amount"]').replaceWith($input);
			let $product_amount = $e.find('*[name="product_amount"]');
			let $qty = $e.find('input[name="product_bom[][quantity]"]');

			$product_amount.on('keyup', function () {
				let qty = window.$(this).cleanNumber({
					decimal: true
				});

				let ratio = $e.find('div[data-name="unit"]').dropdown('get value');
				ratio = parseFloat(ratio);
				if (!ratio) ratio = 1;
				$e.find('input[name="product_bom[][ratio]"]').val(ratio);

				qty = qty * ratio;
				if (qty <= 0) {
					qty = 0;
					window.$(this).val(qty);
				}
				$qty.val(qty);
			}).on('focus', function () {
				window.$(this).select();
			});

			$e.form2('setup', {
				unit_onChange: function (value) {
					$product_amount.trigger('keyup');
				}
			});
			$e.find('div[data-name="unit"]').dropdown('set selected', '1');
		};

		if (product_bom) {
			onClick(product_bom['product']);

			let quantity = parseFloat(product_bom['quantity']) / parseFloat(product_bom['ratio']);
			let result = window.GlobalFunc.getUnitNameByQuantity2({
				product: product_bom['product'],
				quantity: quantity,
				ratio: product_bom['ratio']
			});
			$e.find('*[name="product_amount"]').val(quantity);

			$e.find('div[data-name="unit"]').dropdown('set selected', result['sell_price_ratio'] + '');
			return true;
		}
		let $Search_input = $e.find('*[name="search_product_name"]');
		$Search_input.explorer({
			url: process.env.REACT_APP_DOMAIN + '/api/product',
			additionalData: {
				page: 1,
				limit: 5,
				type: 'normal',
				is_expense: 0,
				is_bom: 0,
				is_serial_number: 0,
				is_not_count_stock: 0,
				exclude_product_id: current_product_id
			},
			key: 'product',
			template: {
				list: '<div class="item flex row">\n    <img class="ui avatar image" src="{{product_image_file_upload.url}}">\n    {{name}}\n</div>',
				selected: {
					text: 'name',
					value: 'id',
					placeholder: 'เลือกสินค้า'
				}
			},
			onClick: function (product) {
				onClick(product);
			}
		});
		setTimeout(function () {
			$e.find('input[name="search"]').focus().select();
		}, 50);
	}

	getProductPrice($form, value) {
		if (!value) value = {};
		let $ProductListUom_root = window.$('.ProductListUom_root');
		let $e = window.$(window.Mustache.render('<div class="ui form flex ProductSellPrice_list">\n    <div class="four fields flex row" style="margin-bottom: 0.7em;-webkit-align-items: flex-end;align-items: flex-end;">\n\t\t<input type="hidden" name="sell_price[][product_price_id]" value="{{id}}">\n\t\t<input type="hidden" name="sell_price[][product_id]" value="{{product_id}}">\n\t\t<input type="hidden" name="sell_price[][is_delete]" value="0">\n        <div class="field">\n            <label style="{{style}}">หน่วยนับ</label>\n            <input type="text" name="sell_price[][unit_name]" placeholder="" value="{{unit_name}}">\n        </div>\n        <div class="field">\n            <label style="{{style}}">จำนวน (อัตราส่วน)</label>\n            <input type="text" name="sell_price[][ratio]" placeholder="อัตราส่วน" value="{{ratio}}">\n        </div>\n        <div class="field">\n            <label style="{{style}}">ราคาขายปลีก</label>\n            <input type="text" name="sell_price[][sell_price_1]" placeholder="บาท" class="ProductListUom_inputPrice1"\n                   value="{{sell_price_1}}">\n        </div>\n        <div class="field">\n            <label style="{{style}}">ราคาขายส่ง</label>\n            <input type="text" name="sell_price[][sell_price_2]" placeholder="บาท" class="ProductListUom_inputPrice2"\n                   value="{{sell_price_2}}">\n        </div>\n        <div class="ui icon button" id="remove"><i class="remove icon"></i></div>\n    </div>\n    <div class="four fields flex row" style="margin-bottom: 0.7em;-webkit-align-items: flex-end;align-items: flex-end;">\n        <div class="field"><label style="{{style}}">&nbsp;</label></div>\n        <div class="field"><label style="{{style}}">&nbsp;</label></div>\n        <div class="field">\n            <label style="{{style}}">ราคาซื้อ</label>\n            <input type="text" name="sell_price[][buy_price_1]" placeholder="บาท" class="ProductListUom_inputPrice1"\n                   value="{{buy_price_1}}">\n        </div>\n        <div class="field"><label style="{{style}}">&nbsp;</label></div>\n\t\t<div class="ui icon button" style="opacity: 0;"><i class="icon"></i></div>\n    </div>\n</div>', value));
		$e.find('#remove').on('click', function () {
			window.Global.confirm({
				title: 'ต้องการลบหรือไม่ ?',
				content: '<form class="ui form">\n\t<p>โปรดยืนยันลบข้อมูลหน่วยนับ</p>\n\t<div class="ui error message"></div>\n</form>',
				cancel_text: 'ไม่ดำเนินการ',
				approve_text: 'ลบข้อมูล',
				onApprove: () => {
					if (!value['id']) {
						$e.remove();
						Product.onDoneEditUom();
					}
				},
			});
		});
		if (value['id']) {
			$e.find('input[name="sell_price[][ratio]"]').attr('readonly', 'readonly');
			$e.find('.button').remove();
		}
		$e.find('*[name="sell_price[][unit_name]"]').on('keyup', function () {
			Product.onDoneEditUom();
		});

		$e.find('input[name="sell_price[][ratio]"]').on('keyup', function () {
			window.$(this).cleanNumber({
				decimal: false
			});
			$form.find('input[name="initial_stock_on_hand2"]').trigger('keyup');
		}).on('focus', function () {
			window.$(this).select();
		});

		$e.find('.ProductListUom_inputPrice1').on('keyup', function () {
			window.$(this).cleanNumber();
		}).on('focus', function () {
			window.$(this).select();
		});

		$e.find('.ProductListUom_inputPrice2').on('keyup', function () {
			window.$(this).cleanNumber();
		}).on('focus', function () {
			window.$(this).select();
		});

		if ($ProductListUom_root.find('.ProductSellPrice_list').length === 0) {
			$e.find('input[name="sell_price[][ratio]"]').attr('readonly', 'readonly');
			return $e;
		}

		$e.find('*[name="sell_price[][ratio]"]').next().hide();

		return $e;
	}

	prepare() {
		let $form = this.$parent.find('form');

		$form.find('input[name="default_supplier_id"]').explorer({
			url: process.env.REACT_APP_DOMAIN + '/api/relationship',
			additionalData: {
				page: 1,
				limit: 20,
				is_supplier: 1
			},
			key: 'relationship',
			multiple: false,
			template: {
				list: '<a class="item flex row">{{name}}</a>',
				selected: {
					text: 'name',
					value: 'id',
					placeholder: 'ไม่ระบุ'
				}
			}
		});
		$form.find('input[name="initial_stock_location_id"]').explorer({
			url: process.env.REACT_APP_DOMAIN + '/api/stock',
			additionalData: {
				page: 1,
				limit: 20,
			},
			key: 'stock',
			multiple: false,
			template: {
				list: '<a class="item flex row">{{name}}</a>',
				selected: {
					text: 'name',
					value: 'id',
					placeholder: 'ไม่ระบุ'
				}
			}
		});

		let ProductData = {};
		let ajax = {
			'uom': {
				method: 'GET',
				url: process.env.REACT_APP_DOMAIN + '/api/uom',
				data: {
					all: true
				},
				done: function (response) {
					if (!response.success) return;
					ProductData.response_uom = response.uom;
				}
			},
			'filter': {
				method: 'GET',
				url: process.env.REACT_APP_DOMAIN + '/api/filter',
				data: {
					all: true,
					type: 'product_category,product_brand,product_color,project'
				},
				done: function (response) {
					if (!response.success) return;
					ProductData.response_product_filter = response.filter;
				}
			}
		};

		let $uom = $form.find('*[name="uom_id"]');

		window.Global.getDataViaMultiAjax().load(ajax).done((response) => {
			$form.find('.ui.checkbox').checkbox();

			window.$.each(ProductData.response_uom, function (i, value) {
				$uom.append(window.Mustache.render('<option value="{{id}}">{{name}}</option>', value));
			});

			window.$.each(ProductData.response_product_filter, function (i, value) {
				if (value['type'] === 'product_category') {
					$form.find('*[name="category"]').append(window.Mustache.render('<option value="{{name}}">{{name}}</option>', value));
				}
				if (value['type'] === 'product_brand') {
					$form.find('*[name="brand"]').append(window.Mustache.render('<option value="{{name}}">{{name}}</option>', value));
				}
				if (value['type'] === 'product_color') {
					$form.find('*[name="color"]').append(window.Mustache.render('<option value="{{name}}">{{name}}</option>', value));
				}
				if (value['type'] === 'project') {
					$form.find('*[name="tags"]').append(window.Mustache.render('<option value="{{name}}">{{name}}</option>', value));
				}
			});

			$form.find('#refresh-uom-button').on('click', function () {
				window.Global.ajax({
					method: 'GET',
					url: process.env.REACT_APP_DOMAIN + '/api/uom',
					data: {
						all: true
					},
					done: function (response) {
						if (!response.success) return;
						ProductData.response_uom = response.uom;
						$uom.html('<option value="null">ไม่ระบุ</option>');
						window.$.each(response.uom, function (i, value) {
							$uom.append(window.Mustache.render('<option value="{{id}}">{{name}}</option>', value));
						});
						$uom.dropdown('refresh');
					}
				});
			});

			let $ProductListBom_root = $form.find('.ProductListBom_root');
			let $ProductListBom_newButton = $form.find('.ProductListBom_newButton');
			$ProductListBom_newButton.off('click').on('click', () => {
				this.getBomManageNode($ProductListBom_root, false, this.state.product ? this.state.product.id : false);
			});

			$form.find('*[name="type"]').off('change').on('change', function () {
				// $form.find('*[data-type]').hide();
				// $form.find('*[data-type="'+this.value+'"]').show();
				window.GlobalFunc.displayOrNot($form, 'data-type', this.value);
			}).trigger('change');


			$form.find('#initial_stock_on_hand_dropdown').dropdown({
				onChange: function (value, text, $choice) {
					$form.find('input[name="initial_stock_on_hand2"]').trigger('keyup');
				}
			});

			window.GlobalFunc.createIsCodeGenerateAuto($form, {
				mode: this.state.mode,
				inputNameDocNo: 'code',
				title: 'รหัสสินค้า',
				defaultRunningNumberId: 'product',
				runningNumberAdditionalData: {
					limit: 30,
					is_default: 0,
					display: 'product',
				},
			});

			$form.form2('setup', {
				is_bom_onChange: (e) => {
					window.GlobalFunc.displayOrNot2($form, [
						{
							attr: 'data-is_bom',
							value: window.$(e).is(':checked') ? '1' : '0'
						},
						{
							attr: 'data-state',
							value: this.state.mode
						}
					])
				},
				is_monthly_payment_onChange: (e) => {
					window.GlobalFunc.displayOrNot2($form, [
						{
							attr: 'data-is_monthly_payment',
							value: window.$(e).is(':checked') ? '1' : '0'
						},
						{
							attr: 'data-state',
							value: this.state.mode
						}
					])
				},
				is_not_count_stock_onChange: (value) => {
					if (parseInt(value) === 0) {
						$form.find('#initial-stock').show();

						$form.find('input[name="is_serial_number"]')
							.prop('readonly', '');
						$form.find('input[name="is_bom"]')
							.prop('readonly', '');
						$form.find('input[name="is_monthly_payment"]')
							.prop('readonly', '');
					} else {
						$form.find('#initial-stock').hide();

						$form.find('input[name="is_serial_number"]')
							.prop('checked', false)
							.prop('readonly', 'readonly');

						$form.find('input[name="is_monthly_payment"]')
							.prop('checked', false)
							.prop('readonly', 'readonly');

						$form.find('input[name="is_bom"]')
							.prop('checked', false)
							.prop('readonly', 'readonly');

						$form.find('.ProductListBom_root').hide();
						$form.find('.ProductListBom_newButton').hide();
					}
				},
			});

			$form.find('input[name="initial_stock_on_hand2"]').on('keyup', function () {
				window.$(this).trigger('change');
			}).on('change', function () {
				let qty = window.$(this).cleanNumber();
				let index = $form.find('#initial_stock_on_hand_dropdown').dropdown('get value');
				if (index === '') {
					window.$(this).val(0);
					$form.find('input[name="initial_stock_on_hand"]').val(0);
					return;
				}
				index = parseInt(index) + 1;
				let ratio = $form.find('.ProductListUom_root > div:nth-child(' + index + ') input[name="sell_price[][ratio]"]').val();
				ratio = parseFloat(ratio);
				if (!ratio) ratio = 0;
				qty = qty * ratio;
				$form.find('input[name="initial_stock_on_hand"]').val(qty);
				if (qty === 0) {
					window.$(this).val(0);
				}
			}).on('focus', function () {
				window.$(this).select();
			});

			$form.find('input[name="name"]').explorer({
				url: process.env.REACT_APP_DOMAIN + '/api/product',
				disable_selected: true,
				min_character: 1,
				additionalData: function () {
					return {}
				},
				key: 'product',
				template: {
					list: function (product) {
						return window.Mustache.render('<a class="item" href="/products/{{id}}" target="_blank">\n    <div><span style="color: #CCC;">อาจซ้ำกับ</span> <span style="color: red;">{{name}}</span></div>\n</a>', product);
					},
					noResult: '<div class="item">ไม่พบชื่อที่ซ้ำกัน</div>'
				}
			});
			let $ProductListUom_root = $form.find('.ProductListUom_root');
			$form.find('*[name="uom_id"]').dropdown({
				onChange: (value, text, $choice) => {
					// console.log(value);
					// console.log(text);
					// console.log($choice);

					let uom = window.$.grep(ProductData.response_uom, function (v) {
						// console.log(v);
						return parseFloat(v.id) === parseFloat(value);
					});
					uom = uom[0];
					// console.log(uom);
					if (!uom) {
						//console.log('ไม่เลือก');
						return false;
					}
					// if ($ProductListUom_root.find('.ProductSellPrice_list').length > 0) {
					// 	let c = window.confirm('ยืนยันกำหนดหน่วยนับและราคาขายสินค้าใหม่หรือไม่? ข้อมูลเดิมจะถูกแทนที่ใหม่');
					// 	if (!c) return false;
					// }
					$ProductListUom_root.empty();
					// สร้างหน่วยนับใหม่ทั้งหมดจาก UOM
					let $e = this.getProductPrice($form, {
						unit_name: uom.base_unit_name,
						ratio: 1
					});
					$ProductListUom_root.append($e);

					window.$.each(uom['compare_unit'], (i, compare_unit) => {
						let $e2 = this.getProductPrice($form, {
							unit_name: compare_unit.name,
							ratio: compare_unit.number
						});
						$ProductListUom_root.append($e2);
					});
					Product.onDoneEditUom();
				}
			});

			this.Pickr = window.Pickr.create({
				el: window.$('.color-picker').get(0),
				theme: 'nano',
				default: null,
				components: {
					// Main components
					preview: true,
					opacity: false,
					hue: true,
					// Input / output Options
					interaction: {
						hex: false,
						rgba: false,
						hsla: false,
						hsva: false,
						cmyk: false,
						input: true,
						clear: true,
						save: true
					}
				}
			})
			this.Pickr.on('save', (color) => {
				// console.log(color, instance);
				// console.log(color.toHEXA().toString());
				if (!color) return;
				this.$parent.find('form').find('input[name="color_hex"]').val(color.toHEXA().toString());
			});
			if (this.state.mode === 'edit' && this.state.product) {
				setTimeout(() => {
					this.$parent.find('form').form2('init', {
						data: this.state.product
					});
					this.Pickr.setColor(this.state.product.color_hex);
					this.$parent.find('form').find('*[name="default_buy_unit_type_index"]').dropdown('set selected', '' + this.state.product.default_buy_unit_type_index || 'null');
					this.$parent.find('form').find('*[name="default_sell_unit_type_index"]').dropdown('set selected', '' + this.state.product.default_sell_unit_type_index || 'null');
					this.$parent.find('#Product_editRoot').find('.ui.segment.loading').removeClass('loading');
				}, 200);
			}
			if (this.state.mode === 'create') {
				$form.find('*[name="default_buy_unit_type_index"]').dropdown('set selected', 'null');
				$form.find('*[name="default_sell_unit_type_index"]').dropdown('set selected', 'null');
				this.$parent.find('#Product_editRoot').find('.ui.segment.loading').removeClass('loading');
			}
			// Product.is_prepare_data = true;
			// window.done();
		});
	}

	getAllPriceConditionPermission() {
		let __product_price_condition = [...this.state.product_price_condition];
		this.state.product_price_condition.forEach((_product_price_condition, _product_price_condition_i) => {
			__product_price_condition[_product_price_condition_i].product_price_condition_permission = [];
			window.Global.ajax({
				method: 'GET',
				url: process.env.REACT_APP_DOMAIN + '/api/product_price_condition_permission',
				data: {
					product_price_condition_id: _product_price_condition.id,
				},
				done: (response) => {
					__product_price_condition[_product_price_condition_i].product_price_condition_permission = response.product_price_condition_permission;
					this.setState({
						product_price_condition: __product_price_condition,
					})
				}
			});
		});
	}

	view() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/product',
			data: {
				product_id: this.state.params.product_id,
				request_product_bom_adjustment_cost: true,
				request_initial_stock_location: true,
				request_product_gallery_file_upload: true,
				type: 'stair_step',
				request_data_product_price_condition_permission: true,
				request_data_product_stock_branch: true,
			},
			done: (response) => {
				let product = response.product[0] || false;
				if (!product) {
					this.setState({
						product: product,
						is_loading: false,
					}, () => {
						window.Global.reactToDom(
							window.$('#product-gallery-file-upload'),
							<ProductGalleryFileUpload
								mode={"list"}
								product={this.state.product}
							/>
						)
					})
				}
				if (product) {
					window.Global.ajax({
						method: 'GET',
						url: process.env.REACT_APP_DOMAIN + '/api/product_price_condition',
						data: {
							type: 'custom',
							product_id: product.id,
							request_data_product_price_condition_permission: true,
						},
						done: (response) => {
							let product_price_condition = response.product_price_condition || false;
							this.setState({
								product: product,
								product_price_condition: product_price_condition,
								is_loading: false,
							}, () => {
								// if (product_price_condition && product_price_condition.length > 0) {
								// 	this.getAllPriceConditionPermission();
								// }
								window.Global.reactToDom(
									window.$('#product-gallery-file-upload'),
									<ProductGalleryFileUpload
										mode={"list"}
										product={this.state.product}
									/>
								)
							})

						}
					});
				}

			},
			fail: () => {

			}
		});
	}

	renderView() {
		return (
			<div ref={(ref) => {
				this.$parent = window.$(ref);
			}} className="main ui container">
				<div style={{marginBottom: '1rem'}}>
					<div className="flex row wrap middle-xs">
						<div className="ui huge breadcrumb">
							<Link className={"section active"}
							      to={"/v2/products"}>สินค้า</Link>
							{
								this.state.product ?
									<>
										<span className="divider" style={{margin: '0px 1rem'}}>/</span>
										<div className="section">
											{this.state.product.name} {this.state.product.code ? <>({this.state.product.code})</> : null}
										</div>
									</>
									: null
							}
							{
								this.state.product.is_deleted
									? <div className={"section flex row middle-xs"} style={{margin: '0 0 0 1rem'}}>
										<span className="ui red empty circular label"/>&nbsp;ยกเลิก
									</div>
									: null
							}
						</div>
						<div className="right floated">
							<Link className="ui positive button"
							      to={"/v2/products/new"}>เพิ่มสินค้าใหม่</Link>
							{
								!this.state.product.is_deleted
								&&
								<Link className={"ui button"}
								      to={"/v2/products/" + this.state.product.id + "/edit"}>แก้ไข</Link>
							}
						</div>
					</div>
					<ProductsMenu product_id={this.state.product.id} index={0}/>
				</div>
				<div id="Product_viewRoot" className={"flex row wrap padded"} style={{marginBottom: '1em'}}>
					{
						!this.state.product && !this.state.is_loading ?
							<div className={"main-section col-xs-16 col-lg-16 padded"}>
								ไม่มีข้อมูลสินค้า
							</div>
							:
							<>
								<div className={"main-section col-xs-16 col-lg-12 padded"}>
									<div className={this.state.is_loading ? "ui form loading" : "ui form"}>
										<div className="ui tall stacked padded segment">
											<div className="ui grid" style={{marginTop: 0}}>
												<div className="doubling two column row" style={{paddingTop: 0}}>
													<div className="column">
														<h4 className="ui dividing header">รายละเอียด</h4>
														<div className="two fields">
															<div className="field">
																<label>ชื่อสินค้า</label>
																<p>{this.state.product.name}</p>
															</div>
															<div className="field">
																<label>ชื่อสินค้าภาษาอังกฤษ</label>
																<p>{this.state.product.name_en || '-'}</p>
															</div>
														</div>
														<div className="field">
															<label>ชื่อบนเอกสาร</label>
															<p data-form2_text="">{this.state.product.name_on_document || '-'}</p>
														</div>
														<div className="two fields">
															<div className="field">
																<div className="field">
																	<label>รูปสินค้า</label>
																	<div>
																		{
																			this.state.product
																			&& this.state.product.product_image_file_upload
																			&& this.state.product.product_image_file_upload.url ?
																				<img
																					src={this.state.product.product_image_file_upload.url}
																					style={{width: 100, height: 100}}
																					alt={"Product"}
																				/>
																				: null
																		}
																	</div>
																</div>
																<div className="field" style={{marginTop: '1rem'}}>
																	<label>สี</label>
																	{
																		this.state.product.color_hex ?
																			<div style={{
																				width: 30,
																				height: 30,
																				backgroundColor: this.state.product.color_hex
																			}}/>
																			: <i className={"close icon red"}/>
																	}
																</div>
															</div>
															<div className="field">
																<div className="field">
																	<label>สินค้ามี Serial Number</label>
																	<p>
																		{
																			this.state.product.is_serial_number ?
																				<>
																					<i className="check icon green"
																					   style={{width: 'initial'}}/> ใช่
																				</>
																				:
																				<>
																					<i className="close icon red"
																					   style={{width: 'initial'}}/> ไม่ใช่
																				</>
																		}
																	</p>
																</div>
																<div className="field" style={{margin: '1rem 0 0 0'}}>
																	<label>ประเภท</label>
																	<p>
																		{
																			this.state.product.is_not_count_stock
																				?
																				<>
																					<i className="close icon red"
																					   style={{width: 'initial'}}/> ไม่นับสต๊อก
																					(สินค้าบริการ)
																				</>
																				:
																				<>
																					<i className="check icon green"
																					   style={{width: 'initial'}}/> สินค้านับสต๊อก
																					&nbsp;&nbsp;<span className={'link'} onClick={() => {
																					window.Global.confirm({
																						title: 'แก้ไขประเภทสินค้า: ' + this.state.product.name,
																						content: '<form class="ui form">\n    <div>\n        <span class="ui label red">โปรดอ่านและทำความเข้าใจก่อนดำเนินการ</span>\n        <br><br>คุณกำลังแก้ไขประเภทสินค้าจาก <u style="color: red">สินค้านับสต๊อก</u> ไปเป็น <u style="color: green">สินค้าไม่นับสต๊อก (สินค้าบริการ)</u>\n        <br>หลังจากแก้ไข ข้อมูลจำนวนสต๊อกที่ผ่านมาจะถูกลบออก และไม่สามารถดูจำนวนสต๊อกได้อีก\n        <br><br>โปรดยืนยัน การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้\n        <br><br>\n        <span style="opacity: 0.65">\n            <u>คำอธิบายเพิ่มเติม</u>\n            <br>หลังจากสินค้าเป็นประเภท สินค้าไม่นับสต๊อก แล้วจะไม่สามารถแก้ไขไปเป็น สินค้านับสต๊อก ได้อีก\n        </span>\n    </div>\n    <div class="ui error message"></div>\n</form>',
																						cancel_text: 'ยกเลิก',
																						approve_text: 'ฉันเข้าใจ และยืนยันแก้ไข',
																						onShowToSetupForm: ($modal) => {
																							$modal.find('form').form2('setup');
																							$modal.find('form').form2('submit', {
																								method: 'PUT',
																								url: process.env.REACT_APP_DOMAIN + '/api/product/change-to-not-count-stock',
																								loadingButton: $modal.find('.button.approve'),
																								beforeSent: (data) => {
																									data.product_id = this.state.product.id;
																									return data;
																								},
																								onSuccess: (response) => {
																									$modal.modal('hide');
																									window.Global.messageTop({
																										type: 'positive',
																										message: 'บันทึกข้อมูลสำเร็จ'
																									});
																									this.setState({
																										product: {...response.product}
																									});
																								}
																							});
																						}
																					});
																				}}>แก้ไข</span>
																				</>
																		}
																	</p>
																</div>
																<div className="field" style={{margin: '1rem 0 0 0'}}>
																	<label>สัญญารายเดือน</label>
																	<p>
																		{
																			this.state.product.is_monthly_payment ?
																				<>
																					<i className="check icon green"
																					   style={{width: 'initial'}}/> ใช่
																				</>
																				:
																				<>
																					<i className="close icon red"
																					   style={{width: 'initial'}}/> ไม่ใช่
																				</>
																		}
																	</p>
																</div>
																<div className="field" style={{margin: '1rem 0 0 0'}}>
																	<label>เป็นค่าใช้จ่าย
																		(หรือเกี่ยวกับเงินเดือน)</label>
																	<p>
																		{
																			this.state.product.is_expense ?
																				<>
																					<i className="check icon green"
																					   style={{width: 'initial'}}/> ใช่
																				</>
																				:
																				<>
																					<i className="close icon red"
																					   style={{width: 'initial'}}/> ไม่ใช่
																				</>
																		}
																	</p>
																</div>
															</div>
														</div>
														{
															this.state.product.product_bom
															&& this.state.product.product_bom.length > 0 ?
																<div data-is_bom="1">
																	<h4 className="ui dividing header">รายการประกอบสินค้าชุด</h4>
																	<div className="field">
																		<div className="ProductListBom_root">
																			{
																				this.state.product.product_bom.map((product_bom, product_bom_i) => (
																					<div key={product_bom_i}
																					     className="ProductListBom_item flex row middle-xs">
																						<div
																							className="flex row middle-xs thumb-image small">
																							<img
																								src={product_bom.product.product_image_file_upload.url}
																								alt={"Product"}/>
																							<div>
																								<div
																									className="header">{product_bom.product.name}</div>
																								<input type="hidden"
																								       name="product_bom[][product_id]"
																								       value=""/>
																							</div>
																						</div>
																						<div
																							className="field right floated flex row">
																							{parseFloat(product_bom.quantity) / parseFloat(product_bom.ratio)} {Helper.getRatioUnit(product_bom.product, product_bom.ratio).unit_name}
																						</div>
																					</div>
																				))
																			}
																		</div>
																	</div>
																</div>
																: null
														}
														<h4 className="ui dividing header">รายละเอียดเพิ่มเติม</h4>
														<div className="two fields">
															<div className="field">
																<label>หมายเลขรหัส</label>
																<p>{this.state.product.code}</p>
															</div>
															<div className="field">
																<label>หมวดหมู่สินค้า</label>
																<p>
																	{
																		this.state.product
																		&& this.state.product.category
																		&& this.state.product.category.length > 0 ?
																			this.state.product.category.map((category, category_i) => {
																				let text = category;
																				if (category_i > 0) {
																					text = ',' + category;
																				}
																				return (text);
																			})
																			: null
																	}
																</p>
															</div>
														</div>
														<div className="two fields">
															<div className="field">
																<label>ยี่ห้อ</label>
																<p>
																	{
																		this.state.product
																		&& this.state.product.brand
																		&& this.state.product.brand.length > 0 ?
																			this.state.product.brand.map((brand, brand_i) => {
																				let text = brand;
																				if (brand_i > 0) {
																					text = ',' + brand;
																				}
																				return (text);
																			})
																			: '-'
																	}
																</p>
															</div>
														</div>
														<div className="field">
															<label>คำอธิบายสินค้า</label>
															<p data-form2_text="" style={{whiteSpace: 'pre'}}>
																{this.state.product.description || '-'}
															</p>
														</div>
														<div className="field">
															<label>ตัวช่วยกรอกรายละเอียดสินค้าตอนสร้างใบขายสินค้า</label>
															<p data-form2_text="" style={{whiteSpace: 'pre'}}>
																{this.state.product.default_description || '-'}
															</p>
														</div>
														<div className="field">
															<label>Tags</label>
															<p data-form2_text="">
																{
																	this.state.product
																	&& this.state.product.tags
																	&& this.state.product.tags.length > 0 ?
																		this.state.product.tags.map((tag, tag_i) => {
																			let text = tag;
																			if (tag_i > 0) {
																				text = ',' + tag;
																			}
																			return (text);
																		})
																		: '-'
																}
															</p>
														</div>
														<div className="two fields">
															<div className="field">
																<label>อนุญาติซื้อ</label>
																<p>
																	{
																		this.state.product.is_purchasable ?
																			<>
																				<i className="check icon green"
																				   style={{width: 'initial'}}/> ใช่
																			</>
																			:
																			<>
																				<i className="close icon red"
																				   style={{width: 'initial'}}/> ไม่ใช่
																			</>
																	}
																</p>
															</div>
															<div className="field">
																<label>อนุญาติขาย</label>
																<p>
																	{
																		this.state.product.is_saleable ?
																			<>
																				<i className="check icon green"
																				   style={{width: 'initial'}}/> ใช่
																			</>
																			:
																			<>
																				<i className="close icon red"
																				   style={{width: 'initial'}}/> ไม่ใช่
																			</>
																	}
																</p>
															</div>
														</div>
														<div className="field"
														     ref={(ref) => {
															     window.$(ref).form2('init', {
																     data: this.state.product
															     });
														     }}
														>
															<label>ไฟล์แนบ</label>
															<div data-form2_setup="true" data-form2_type="upload"
															     data-input_name="product_file_upload"
															     data-remove_input_name="remove_file_upload"
															     data-is_can_remove="false">
																<div className="Upload_fileRoot flex row wrap"/>
															</div>
														</div>
													</div>
													<div className="column">
														<h4 className="ui dividing header">อื่นๆ</h4>
														<div className="two fields">
															<div className="field">
																<label>แก้ไขล่าสุดโดย</label>
																{
																	this.state.product.updated_user
																		?
																		<div>
																			{this.state.product.updated_user.name} · {window.Global.getDateThai(this.state.product.date_updated)}
																		</div>
																		: null
																}
															</div>
															<div className="field">
																<label>บันทึกโดย</label>
																{
																	this.state.product.created_user
																		?
																		<div>
																			{this.state.product.created_user.name} · {window.Global.getDateThai(this.state.product.date_created)}
																		</div>
																		: null
																}
															</div>
														</div>
														<div className="two fields">
															<div className="field">
																<label>ประเภทภาษี</label>
																<p>
																	{
																		this.state.product.tax_type === 'has_vat' ?
																			"คิดภาษี" : null
																	}
																	{
																		this.state.product.tax_type === 'no_vat' ?
																			"ละเว้นภาษี" : null
																	}
																</p>
															</div>
															<div className="field">
																<label>ซื้อสินค้าจากใคร</label>
																<p data-form2_text="">
																	{
																		this.state.product.default_supplier ?
																			this.state.product.default_supplier.name
																			: '-'
																	}
																</p>
															</div>
														</div>
														<div className="two fields">
															<div className="field">
																<label>หน่วยนับที่ใช้ขาย</label>
																<p>
																	{
																		this.state.product.sell_price
																		&& this.state.product.sell_price.length > 0
																		&& this.state.product.sell_price[this.state.product.default_sell_unit_type_index] ?
																			this.state.product.sell_price[this.state.product.default_sell_unit_type_index].unit_name : '-'
																	}
																</p>
															</div>
															<div className="field">
																<label>หน่วยนับที่ใช้ซื้อ</label>
																<p>
																	{
																		this.state.product.sell_price
																		&& this.state.product.sell_price.length > 0
																		&& this.state.product.sell_price[this.state.product.default_buy_unit_type_index] ?
																			this.state.product.sell_price[this.state.product.default_buy_unit_type_index].unit_name : '-'
																	}
																</p>
															</div>
														</div>
														<div id={"product-gallery-file-upload"}/>
														<div data-is_monthly_payment="0"
														     style={{
															     marginTop: '2rem',
															     display: this.state.product.is_not_count_stock === 0
																     ? 'block'
																     : 'none',
														     }}
														>
															<h4 className="ui dividing header flex row"
															    data-only_new="1">ยอดยกมา
																(สินค้าจากระบบเดิมมาเป็นระบบใหม่)
																<span style={{marginLeft: 'auto'}}
																      className={"link"}
																      onClick={() => {
																	      window.Global.reactToDom(
																		      window.$('body'),
																		      <ProductInitialStock
																			      mode={"edit"}
																			      product={this.state.product}
																			      onSuccess={(response) => {
																				      this.setState({
																					      product: response.product
																				      })
																			      }}
																		      />
																	      )
																      }}
																>
																	แก้ไข
																</span>
															</h4>
															<div className="two fields">
																<div className="field">
																	<label>จำนวน</label>
																	<p>{
																		this.state.product && this.state.product.initial_stock_on_hand ?
																			this.state.product.initial_stock_on_hand.format(2) : 0}
																		{' ' + Helper.getRatioUnitByOrder(this.state.product.sell_price, {return_sell_price: 'min'}).unit_name}
																	</p>
																</div>
																<div className="field">
																	<label>ราคาทุนต่อ{Helper.getRatioUnitByOrder(this.state.product.sell_price, {return_sell_price: 'min'}).unit_name}</label>
																	<p data-text_after="฿">
																		{this.state.product && this.state.product.initial_cost_price_per_unit ? this.state.product.initial_cost_price_per_unit.format(2) : 0}฿
																	</p>
																</div>
															</div>
															<div className="two fields">
																<div className="field">
																	<label>ยอดยกมาเข้าคลังสินค้า</label>
																	<p>
																		{this.state.product && this.state.product.initial_stock_location ? this.state.product.initial_stock_location.name : '-'}
																	</p>
																</div>
																<div className="field">
																	<label>วันที่ยกมา</label>
																	<p>
																		{this.state.product && this.state.product.initial_stock_date ? window.Global.getDateThai(this.state.product.initial_stock_date, {is_show_time: false}) : '-'}
																	</p>
																</div>
															</div>
														</div>
														<div id="product_bom_adjustment_cost"
														     style={{marginTop: '2rem'}}>
															<div className="ui dividing header flex row">
																<h4 style={{marginBottom: 0}}>ต้นทุนการผลิตสินค้า</h4>
															</div>
															<div className="field">

																<div className="ui basic table Table_root theme1"
																     id={"sell_price_discount_table"}>
																	<div className="thead">
																		<div className="tr">
																			<div className="th span5">จำนวนสินค้าหลัก
																			</div>
																			<div className="th span8">สินค้าต้นทุน</div>
																			<div className="th span5">จำนวน</div>
																		</div>

																	</div>
																	<div className="tbody Item_root">
																		{
																			this.state.product
																			&& this.state.product.product_bom_adjustment_cost
																			&& this.state.product.product_bom_adjustment_cost.length > 0 ?
																				this.state.product.product_bom_adjustment_cost.map((product_bom_adjustment_cost, product_bom_adjustment_cost_i) => {
																					return (
																						<div className="tr"
																						     key={product_bom_adjustment_cost_i}
																						     onClick={() => {
																							     ProductBomAdjustmentCost.manage(this.state.product, product_bom_adjustment_cost);
																						     }}
																						     style={{cursor: 'pointer'}}
																						>
																							<div
																								className="td span5 ">
																								{product_bom_adjustment_cost.material_ratio_quantity2}
																							</div>
																							<div
																								className="td span8 ">
																								<div>
																									{product_bom_adjustment_cost.cost_product.name}
																									<span
																										className="ui label edit"
																										style={{display: 'inline-flex'}}>แก้ไข</span>
																								</div>
																							</div>
																							<div
																								className="td span5 ">
																								{product_bom_adjustment_cost.cost_product_quantity2}
																							</div>
																						</div>
																					);
																				})
																				:
																				null
																		}
																		<div className="tr">
																			<div
																				className="th span16">
																				<div className={"row center-xs"}>
																					<div className="ui button"
																					     onClick={() => {
																						     ProductBomAdjustmentCost.manage(this.state.product);
																					     }}
																					>เพิ่มรายการ
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>

															</div>
														</div>
													</div>
												</div>
											</div>
											{
												this.state.product.is_draft ?
													<div className={"flex row"} style={{justifyContent: 'flex-end'}}>
														<div className="flex row middle-xs" style={{marginRight: 15}}>
														<span
															className="ui yellow empty circular label"/>&nbsp;ฉบับร่างรออนุมัติ
														</div>
														<button className={"ui button basic green"} type={"button"}
														        ref={(ref) => {
															        this.approve_btn = window.$(ref)
														        }}
														        onClick={() => {
															        let $this = this.approve_btn;
															        if ($this.hasClass('loading')) return;
															        $this.addClass('loading');
															        window.Global.confirm({
																        title: 'อนุมัติสินค้า ' + this.state.product.name,
																        content: '<form class="ui form">\n\t<p>โปรดยืนยันการอนุมัติสินค้า</p>\n\t<div class="ui error message"></div>\n</form>',
																        cancel_text: 'ยกเลิก',
																        approve_text: 'ตกลง',
																        onApprove: ($modal) => {
																	        window.Global.ajax({
																		        method: 'PUT',
																		        url: process.env.REACT_APP_DOMAIN + '/api/product/approve',
																		        data: {
																			        product_id: this.state.product.id
																		        },
																		        done: (response) => {
																			        $this.removeClass('loading');
																			        if (!response.success) {
																				        return;
																			        }
																			        window.Global.messageTop({
																				        type: 'positive',
																				        message: 'อนุมัติสินค้าเรียบร้อย'
																			        });
																			        $this.closest('.flex.row').remove();
																		        }
																	        });
																        },
																        onDeny: ($modal) => {
																	        $this.removeClass('loading');
																	        $modal.modal('hide');
																        }
															        });

														        }}
														>
															อนุมัติ
														</button>
													</div>
													: null
											}

										</div>
									</div>
								</div>
								<div className={"right-section col-xs-16 col-lg-4 padded"}>
									<div className="ui segment">
										{/*<div className="ui header flex row align">*/}
										{/*	<h3 style={{margin: 0}}>ราคาพิเศษ</h3>*/}
										{/*</div>*/}
										<a className="ui button green fluid"
										   style={{borderRadius: 4}}
										   href={"/v2/shipments?has_product_ids=" + this.state.product.id + "&order_by=done_date_desc"}
										>
											<i className="info icon" style={{height: 'initial'}}/> ดูประวัติล่าสุด
										</a>
										<div className="ui button green basic fluid"
										     style={{borderRadius: 4, margin: '1rem 0 0 0'}}
										     onClick={() => {
											     window.Global.reactToDom(
												     window.$('body'),
												     <ShipmentProductAudit
													     product={this.state.product}
												     />
											     );
										     }}
										>
											<i className="history icon" style={{height: 'initial'}}/> ตรวจสอบสินค้า
										</div>
									</div>
									<div className="ui segment">
										<div className="ui header flex row align be">
											<div>
												<h3 style={{margin: 0}}>ราคาขาย/ซื้อสินค้า</h3>
											</div>
											<div className="right floated">
												<a href="/permission/product_price_condition"
												   target="_blank">ตั้งค่ารายชื่อลูกค้าราคาขายส่ง</a>
											</div>
										</div>
										<div className="ui divided items" style={{margin: '0'}}>
											<div className="ui relaxed list" style={{margin: '0'}}>
												{
													this.state.is_loading ?
														<div className="item" style={{padding: '1rem'}}>
															<div className="ui active centered inline loader"/>
														</div>
														: this.state.product
														&& this.state.product.sell_price
														&& this.state.product.sell_price.length > 0 ?
															this.state.product.sell_price.map((sell_price, sell_price_i) => {
																return (
																	<div className="item" key={sell_price_i}
																	     style={(sell_price_i) % 2 === 0 ? {
																		     backgroundColor: '#f4f4f5',
																		     padding: '1rem',
																		     border: '1px solid #f4f4f5'
																	     } : {
																		     padding: '1rem',
																		     border: '1px solid #f4f4f5'
																	     }}
																	>
																		<div className="content flex row">
																			<div className={"description"}
																			     style={{lineHeight: 1.3}}>
																				<strong style={{color: '#000'}}>
																					{sell_price.unit_name} ({sell_price.ratio})
																				</strong><br/>
																				ราคาซื้อ ฿{sell_price.buy_price_1.format(2)}
																			</div>
																			<div className="description right floated"
																			     style={{
																				     textAlign: 'right',
																				     color: 'green',
																				     fontWeight: 'bold',
																				     lineHeight: 1.3
																			     }}>
																				ขายปลีก ฿{sell_price.sell_price_1.format(2)}
																				<br/>
																				ขายส่ง ฿{sell_price.sell_price_2.format(2)}
																			</div>
																		</div>
																	</div>
																);
															})
															:
															<div className="item">
																ไม่มีข้อมูล
															</div>
												}
											</div>
										</div>
									</div>
									<div className="ui segment">
										<div className="ui header flex row align">
											<h3 style={{margin: 0}}>ขั้นบันไดราคาขายสินค้า</h3>
										</div>
										<div className="ui divided items" style={{margin: '0'}}>
											<div className="ui relaxed list"
											     style={{margin: '0'}}>
												{
													this.state.is_loading ?
														<div className="item" style={{padding: '1rem'}}>
															<div className="ui active centered inline loader"/>
														</div>
														:
														this.state.product
														&& this.state.product.stair_step_product_price_condition
														&& this.state.product.stair_step_product_price_condition.length > 0
															?
															this.state.product.stair_step_product_price_condition.map((stair_step_product_price_condition, stair_step_product_price_condition_i) => {
																return (
																	<div className="item"
																	     key={stair_step_product_price_condition_i}
																	     style={(stair_step_product_price_condition_i) % 2 === 0 ? {
																		     backgroundColor: '#f4f4f5',
																		     padding: '1rem',
																		     border: '1px solid #f4f4f5'
																	     } : {
																		     padding: '1rem',
																		     border: '1px solid #f4f4f5'
																	     }}
																	>
																		<div className="content flex row middle-xs">
																			<div className={"flex row middle-xs"}>
																				<strong style={{color: '#000'}}>
																					{stair_step_product_price_condition.product_price_condition_stair_step.begin_quantity} {Helper.getRatioUnit(this.state.product, stair_step_product_price_condition.ratio).unit_name}
																					&nbsp;-&nbsp;
																					{stair_step_product_price_condition.product_price_condition_stair_step.maximum_quantity} {Helper.getRatioUnit(this.state.product, stair_step_product_price_condition.ratio).unit_name}
																				</strong>
																				<span data-tooltip="แก้ไข"
																				      data-inverted={true}
																				      style={{
																					      marginLeft: 5,
																					      cursor: 'pointer',
																					      color: '#000'
																				      }}
																				>
																					<i className={"edit icon"}
																					   onClick={() => {
																						   Product.manageProductSellPriceDiscount(
																							   this.state.product, stair_step_product_price_condition,
																							   {
																								   onEdited: (response) => {
																									   let product = {...this.state.product};
																									   product.stair_step_product_price_condition[stair_step_product_price_condition_i] = response.product_price_condition;
																									   this.setState({
																										   product: product
																									   })
																								   },
																								   onDeleted: (response) => {
																									   if (response.success) {
																										   let product = {...this.state.product};
																										   product.stair_step_product_price_condition.splice(stair_step_product_price_condition_i, 1);
																										   this.setState({
																											   product: product
																										   })
																									   }
																								   }
																							   }
																						   );
																					   }}
																					/>
																				</span>
																			</div>
																			<div className="description right floated"
																			     style={{
																				     textAlign: 'right',
																				     color: 'green',
																				     fontWeight: 'bold',
																				     lineHeight: 1.3
																			     }}>
																				{
																					stair_step_product_price_condition.price > 0 ?
																						<div style={{
																							textDecoration: stair_step_product_price_condition.discount > 0
																							&& stair_step_product_price_condition.summary.total_net_price > 0 ? 'line-through' : null
																						}}>
																							฿{stair_step_product_price_condition.price.format(2)}<br/>
																						</div>
																						: null
																				}
																				{
																					stair_step_product_price_condition.discount > 0 ?
																						<div>
																							ส่วนลด {stair_step_product_price_condition.discount_type === '฿' ? '฿' : null}{stair_step_product_price_condition.discount.format(2)}
																							{stair_step_product_price_condition.discount_type === '%' ? '%' : null}
																						</div>
																						: null
																				}
																				{
																					stair_step_product_price_condition.discount > 0
																					&& stair_step_product_price_condition.summary.total_net_price > 0 ?
																						<div>
																							฿{stair_step_product_price_condition.summary.total_net_price}
																						</div>
																						: null
																				}
																			</div>
																		</div>
																		<div style={{
																			width: '100%',
																			flexWrap: 'wrap'
																		}}>
																			<ProductPriceConditionPermission
																				mode={"view"}
																				product={this.state.product}
																				product_price_condition={stair_step_product_price_condition}
																				product_price_condition_permission={stair_step_product_price_condition.product_price_condition_permission}
																			/>
																		</div>
																	</div>
																);
															})
															: null
												}
											</div>
											{
												this.state.product ?
													<div style={{marginTop: '1rem'}}>
														<div id="create-invoice-button"
														     className="ui button fluid"
														     style={{borderRadius: 4}}
														     onClick={() => {
															     Product.manageProductSellPriceDiscount(
																     this.state.product,
																     false,
																     {
																	     onCreated: (response) => {
																		     let product = {...this.state.product};
																		     product.stair_step_product_price_condition.push(response.product_price_condition);
																		     this.setState({
																			     product: product
																		     })
																	     }
																     });
														     }}
														>
															เพิ่มเงื่อนไข
														</div>
													</div>
													: null
											}
										</div>
									</div>
									<div className="ui segment">
										<div className="ui header flex row align">
											<h3 style={{margin: 0}}>ราคาพิเศษ</h3>
										</div>
										<div className="ui divided items" style={{margin: 0}}>
											<div className="ui relaxed divided list">
												{
													this.state.is_loading ?
														<div className="item">
															<div className="ui active centered inline loader"/>
														</div>
														: this.state.product
														&& this.state.product_price_condition
														&& this.state.product_price_condition.length > 0 ?
															this.state.product_price_condition.map((product_price_condition, product_price_condition_i) => {
																//console.log(product_price_condition.product_price_condition_permission);
																return (
																	<div className="item" key={product_price_condition_i}
																	     style={(product_price_condition_i) % 2 === 0 ? {
																		     backgroundColor: '#f4f4f5',
																		     padding: '1rem',
																		     border: '1px solid #f4f4f5'
																	     } : {
																		     padding: '1rem',
																		     border: '1px solid #f4f4f5'
																	     }}

																	>
																		<div className="content">
																			<div className={"flex row"}>
																				<div className={"flex row middle-xs"}>
																					<div className={"description"}
																					     style={{color: '#000'}}>
																						{
																							product_price_condition.name
																								?
																								<div>
																									<b>{product_price_condition.name}</b>
																								</div>
																								: null
																						}
																						<div>
																							<strong>
																								{
																									product_price_condition.ratio !== 'all' ?
																										Helper.getRatioUnit(this.state.product, product_price_condition.ratio).unit_name
																										: null
																								}
																								{
																									!product_price_condition.product_price_id ?
																										"ทุกหน่วยนับ"
																										: null
																								}
																							</strong>
																							<span data-tooltip="แก้ไข"
																							      data-inverted={true}
																							      style={{
																								      marginLeft: 5,
																								      cursor: 'pointer',
																								      color: '#000'
																							      }}
																							>
																						<i className={"edit icon"}
																						   onClick={() => {
																							   window.Global.reactToDom(
																								   window.$('body'),
																								   <ProductPriceCondition
																									   mode={"edit"}
																									   product_price_condition={product_price_condition}
																									   product={this.state.product}
																									   onDelete={(product_price_condition) => {
																										   this.void(
																											   process.env.REACT_APP_DOMAIN + '/api/product_price_condition',
																											   {product_price_condition_id: product_price_condition.id},
																											   {
																												   onSuccess: (response) => {
																													   let _product_price_condition = this.state.product_price_condition.filter((__product_price_condition) => {
																														   return __product_price_condition.id !== product_price_condition.id
																													   });
																													   this.setState({
																														   product_price_condition: _product_price_condition
																													   })
																												   }
																											   }
																										   );
																									   }}
																									   EditSuccess={(response) => {
																										   // console.log(response);
																										   let _product_price_condition = [...this.state.product_price_condition];
																										   _product_price_condition[product_price_condition_i] = Object.assign(this.state.product_price_condition[product_price_condition_i], response.product_price_condition);
																										   this.setState({
																											   product_price_condition: _product_price_condition,
																										   })
																									   }}
																								   />
																							   )
																						   }}
																						/>
																						</span>
																						</div>
																						{
																							product_price_condition.description
																								?
																								<div
																									style={{whiteSpace: 'pre-line'}}>
																									{product_price_condition.description}
																								</div>
																								: null
																						}
																					</div>
																				</div>
																				<div className="description right floated"
																				     style={{
																					     textAlign: 'right',
																					     color: 'green',
																					     fontWeight: 'bold',
																					     lineHeight: 1.3,
																				     }}>
																					{
																						product_price_condition.product_price_id ?
																							(
																								<div
																									style={{textDecoration: product_price_condition.discount > 0 ? 'line-through' : null}}>
																									฿{product_price_condition.price ? product_price_condition.price.format(2) : 0}<br/>
																								</div>
																							)
																							: null
																					}
																					{
																						product_price_condition.discount > 0 ?
																							<div>
																								ส่วนลด {product_price_condition.discount_type === '฿' ? '฿' : null}{product_price_condition.discount.format(2)}
																								{product_price_condition.discount_type === '%' ? '%' : null}
																							</div>
																							: null
																					}
																					{
																						product_price_condition.discount > 0
																						&& product_price_condition.summary.total_net_price > 0 ?
																							<div>
																								฿{product_price_condition.summary.total_net_price}
																							</div>
																							: null
																					}
																				</div>
																			</div>
																			<div style={{
																				width: '100%',
																				flexWrap: 'wrap'
																			}}>
																				<ProductPriceConditionPermission
																					mode={"view"}
																					product={this.state.product}
																					product_price_condition={product_price_condition}
																					product_price_condition_permission={product_price_condition.product_price_condition_permission}
																				/>
																			</div>
																		</div>
																	</div>
																);
															})
															: null
												}
												{
													this.state.product
														?
														<div style={{marginTop: '1rem'}}>
															<div id="create-invoice-button"
															     className="ui button fluid"
															     onClick={() => {
																     window.Global.reactToDom(
																	     window.$('body'),
																	     <ProductPriceCondition
																		     mode={"create"}
																		     product={this.state.product}
																		     CreateSuccess={(response) => {
																			     let __product_price_condition = response.product_price_condition;
																			     let _product_price_condition = [...this.state.product_price_condition];
																			     window.Global.ajax({
																				     method: 'GET',
																				     url: process.env.REACT_APP_DOMAIN + '/api/product_price_condition_permission',
																				     data: {
																					     product_price_condition_id: __product_price_condition.id,
																				     },
																				     done: (response) => {
																					     __product_price_condition.product_price_condition_permission = response.product_price_condition_permission;
																					     _product_price_condition.push(__product_price_condition);
																					     this.setState({
																						     product_price_condition: _product_price_condition
																					     })
																				     }
																			     });
																		     }}
																	     />
																     )
															     }}
															     style={{borderRadius: 4}}
															>
																กำหนดราคาพิเศษ
															</div>
														</div>
														: null
												}
											</div>
										</div>
									</div>
								</div>
							</>
					}
				</div>
				{
					this.state.product.is_not_count_stock === 0
					&&
					<div className="ui segment">
						<h3 className="ui header">คลังสินค้า</h3>
						<ProductsStock
							mode={"displayQuantityInStock"}
							is_loading={false}
							product={this.state.product}
						/>
					</div>
				}
				<ManageProductSellPriceDiscount product={this.state.product}/>
				<ProductBomAdjustmentCostTemplate product={this.state.product}/>
			</div>
		);
	}

	renderList() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
			     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     className="main ui container">
				<div id="HeaderTop_root" className="flex row wrap">
					<div className="flex row middle-xs center-xs">
						<div className="ui huge breadcrumb" style={{margin: '0 1em 0 0'}}>
							<Link className="active section" to="/v2/products">สินค้า</Link>
						</div>
					</div>
					<div className="right floated">
						<Link className="ui positive button"
						      to={"/v2/products/new"}>เพิ่มสินค้าใหม่</Link>
					</div>
				</div>
				{
					<FilterGroup
						onInit={(ref) => {
							let $search = window.$(ref.current);

							window.Search.init({
								$node: $search,
								onSubmit: (data) => {
									this.props.history.push(window.Global.getQueryStringLinkFromObject(data));
									return false;
								}
							});
							$search.find('input[name="filter_product_category_id"]').explorer({
								url: process.env.REACT_APP_DOMAIN + '/api/filter',
								additionalData: {
									limit: 30,
									page: 1,
									type: 'product_category'
								},
								key: 'filter',
								template: {
									list: '<a class="item flex row">{{name}}</a>',
									selected: {
										text: 'name',
										value: 'id',
										placeholder: 'ไม่มีระบุ'
									}
								}
							});
							$search.find('input[name="filter_product_brand_id"]').explorer({
								url: process.env.REACT_APP_DOMAIN + '/api/filter',
								additionalData: {
									limit: 30,
									page: 1,
									type: 'product_brand'
								},
								key: 'filter',
								template: {
									list: '<a class="item flex row">{{name}}</a>',
									selected: {
										text: 'name',
										value: 'id',
										placeholder: 'ไม่มีระบุ'
									}
								},
							});
							$search.find('input[name="filter_product_id"]').explorer({
								url: process.env.REACT_APP_DOMAIN + '/api/filter',
								additionalData: {
									limit: 30,
									page: 1,
									type: 'product'
								},
								key: 'filter',
								template: {
									list: '<a class="item flex row">{{name}}</a>',
									selected: {
										text: 'name',
										value: 'id',
										placeholder: 'ไม่มีระบุ'
									}
								},
							});

							$search.find('input[name="product_price_unit_name[]"]').explorer({
								url: process.env.REACT_APP_DOMAIN + '/api/v1/product-price',
								additionalData: {
									limit: 30,
									page: 1,
								},
								multiple: true,
								key: 'product_price',
								template: {
									list: '<a class="item flex row">{{unit_name}}</a>',
									selected: {
										text: 'unit_name',
										value: 'unit_name',
										placeholder: 'ไม่ระบุ'
									}
								},
								exclude: {
									sentKeyData: 'exclude_project_id',
									key: 'id'
								}
							});

							setTimeout(function () {
								$search.find('.pointing.dropdown').dropdown({
									onChange: function (value) {
										let data = $search.find('form').serializeObject();
										if (value === 'excel') {
											data.is_download_excel = true;
											window.Global.reactToDom(
												window.$('body'),
												<DownloadReportModal url={process.env.REACT_APP_DOMAIN + '/api/product'}
												                     data={data}/>
											);
										}
									}
								});
							});
						}}
						children={
							<>
								<div className="col-span-2 field">
									<label>ค้นหาสินค้า/รหัสสินค้า</label>
									<input name="search_query" data-form2_setup="" placeholder={"ชื่อสินค้า"}/>
								</div>
								<div className="field">
									<label>ค้นหาบาร์โค้ด</label>
									<input name="search_query_barcode" data-form2_setup="" placeholder={"บาร์โค้ด"}/>
								</div>
								<div className="field">
									<label>เรียงข้อมูล</label>
									<div className="field">
										<select className="ui dropdown"
										        name="order_by"
										        data-form2_setup="">
											<option value="newest">ใหม่สุด</option>
											<option value="oldest">เก่าสุด</option>
											<option value="name_asc">ชื่อ A-Z</option>
											<option value="name_desc">ชื่อ Z-A</option>
											<option value="code_asc">รหัสสินค้า A-Z</option>
											<option value="code_desc">รหัสสินค้า Z-A</option>
										</select>
									</div>
								</div>
								<div className="field">
									<label>ไม่นับสต๊อก</label>
									<div className="field">
										<select className="ui dropdown"
										        name="is_not_count_stock"
										        data-form2_setup="">
											<option value="">ทั้งหมด</option>
											<option value="1">ใช่</option>
											<option value="0">ไม่ใช่</option>
											<option value="all">ทั้งหมด</option>
										</select>
									</div>
								</div>
								<div className="field">
									<label>ค่าใช้จ่าย</label>
									<div className="field">
										<select className="ui dropdown"
										        name="is_expense"
										        data-form2_setup="">
											<option value="">ทั้งหมด</option>
											<option value="1">ใช่</option>
											<option value="0">ไม่ใช่</option>
											<option value="all">ทั้งหมด</option>
										</select>
									</div>
								</div>
								<div className="field">
									<label>Tags</label>
									<input name="filter_product_id" data-form2_setup="" placeholder={"ไม่ระบุ"}/>
								</div>
								<div className="field">
									<label>จำนวนต่อหน้า</label>
									<div className="field">
										<select className="ui dropdown"
										        name="limit"
										        data-form2_setup="">
											<option value="">ไม่กำหนด</option>
											<option value="10">10</option>
											<option value="30">30</option>
											<option value="50">50</option>
											<option value="100">100</option>
											<option value="300">300</option>
										</select>
									</div>
								</div>
								<div className="field">
									<label>หมวดหมู่สินค้า</label>
									<input name="filter_product_category_id" data-form2_setup="" placeholder={"ไม่ระบุ"}/>
								</div>
								<div className="field">
									<label>ยี่ห้อ</label>
									<input name="filter_product_brand_id" data-form2_setup="" placeholder={"ไม่ระบุ"}/>
								</div>
								<div className="field">
									<label>ชื่อหน่วยนับ</label>
									<input name="product_price_unit_name[]"/>
								</div>
								<div className="field">
									<label>จำนวนหน่วยนับ</label>
									<div className="field">
										<select className="ui dropdown"
										        name="number_of_product_price"
										        data-form2_setup="">
											<option value="all">ไม่กำหนด</option>
											<option value="1">เฉพาะสินค้าที่มี 1 หน่วยนับ</option>
											<option value="many">เฉพาะสินค้าที่มีมากกว่า 1 หน่วยนับ</option>
										</select>
									</div>
								</div>
								<div className="field">
									<label>สินค้าประกอบชุด</label>
									<div className="field">
										<select className="ui dropdown"
										        name="is_bom"
										        data-form2_setup="">
											<option value="">ทั้งหมด</option>
											<option value="1">ใช่</option>
											<option value="0">ไม่ใช่</option>
											<option value="all">ทั้งหมด</option>
										</select>
									</div>
								</div>
								<div className="field">
									<label>สถานะ</label>
									<div className="field">
										<select className="ui dropdown"
										        name="status"
										        data-form2_setup="">
											<option value="active">ใช้งาน</option>
											<option value="draft">ฉบับร่าง</option>
											<option value="void">ยกเลิก</option>
											<option value="all">ทั้งหมด</option>
										</select>
									</div>
								</div>
								<div className="field">
									<label>อนุญาติขาย</label>
									<div className="field">
										<select className="ui dropdown"
										        name="is_saleable"
										        data-form2_setup="">
											<option value="">ทั้งหมด</option>
											<option value="1">ใช่</option>
											<option value="0">ไม่ใช่</option>
											<option value="all">ทั้งหมด</option>
										</select>
									</div>
								</div>
								<div className="field">
									<label>อนุญาติซื้อ</label>
									<div className="field">
										<select className="ui dropdown"
										        name="is_purchasable"
										        data-form2_setup="">
											<option value="">ทั้งหมด</option>
											<option value="1">ใช่</option>
											<option value="0">ไม่ใช่</option>
											<option value="all">ทั้งหมด</option>
										</select>
									</div>
								</div>
								<div className="field">
									<label>Serial Number</label>
									<div className="field">
										<select className="ui dropdown"
										        name="is_serial_number"
										        data-form2_setup="">
											<option value="">ทั้งหมด</option>
											<option value="1">ใช่</option>
											<option value="0">ไม่ใช่</option>
											<option value="all">ทั้งหมด</option>
										</select>
									</div>
								</div>
								<div className="field">
									<label>สัญญารายเดือน</label>
									<div className="field">
										<select className="ui dropdown"
										        name="is_monthly_payment"
										        data-form2_setup="">
											<option value="">ทั้งหมด</option>
											<option value="1">ใช่</option>
											<option value="0">ไม่ใช่</option>
											<option value="all">ทั้งหมด</option>
										</select>
									</div>
								</div>
							</>
						}
						filterFooter={
							<>
								<div className="flex flex-row items-center justify-between">
									<div style={{marginRight: '0.7em', display: 'none'}}>
										<div className="ui labeled icon  button basic"
										     onClick={() => {
											     window.Global.reactToDom(window.$('body'),
												     <UploadReport/>
											     );
										     }}
										>
											<i className="upload icon"/>
											<span className="text">อัพโหลดรายงาน</span>
										</div>
									</div>
									<button className="ui labeled icon top right button basic"
									        onClick={() => {
										        window.Global.reactToDom(
											        window.$('body'),
											        <div>
												        <Modal className="ui modal tiny"
												               closable={false}
												               onShowToSetupForm={($modal) => {
													               // $modal.find('form').form2('setup');
													               $modal.find('form').form2('setup', {});
													               $modal.find('form').form2('submit', {
														               method: 'POST',
														               url: process.env.REACT_APP_DOMAIN + '',
														               beforeSent: (object) => {
															               $modal.modal('hide');

															               let data = this.$parent.find('form').serializeObject();
															               data.is_download_excel = true;

															               window.Global.reactToDom(
																               window.$('body'),
																               <DownloadReportModal
																	               url={process.env.REACT_APP_DOMAIN + '/api/product'}
																	               data={{
																		               ...data,
																		               ...object
																	               }}
																               />
															               );

															               return false;
														               },
														               loadingButton: $modal.find('.button.approve'),
														               onSuccess: () => {

														               }
													               });
												               }}>
													        <div className="header">
														        <h2>ดาวโหลดรายการสินค้า</h2>
													        </div>
													        <div className="content">
														        <form className="ui form">
															        <div
																        className="flex row wrap column one column computer padded">
																        <div className="column field inline">
																	        <div className="ui checkbox">
																		        <input id="request_data_product_barcode"
																		               type="checkbox"
																		               tabIndex="0"
																		               name="request_data_product_barcode"
																		               className="hidden"
																		               value="0"
																		        />
																		        <label
																			        htmlFor="request_data_product_barcode">แสดง
																			        Barcode
																			        ทั้งหมดของสินค้า</label>
																	        </div>
																        </div>
															        </div>
															        <div className="ui error message"/>
														        </form>
													        </div>
													        <div className="actions">
														        <div className="flex row">
															        <div className="right floated">
																        <div className="ui deny button">ยกเลิก</div>
																        <div
																	        className="ui approve green right button">ดาวโหลด
																        </div>
															        </div>
														        </div>
													        </div>
												        </Modal>
											        </div>
										        );
									        }}
									        type="button">
										<i className="download icon"/>
										<span className="text">ดาวโหลดรายงาน</span>
									</button>
									<button className="ui icon button primary" type="submit">
										<i className="search icon"/>&nbsp;&nbsp;ค้นหา
									</button>
								</div>
							</>
						}
						table={
							<div className="ui basic table can click Table_root td-top-xs !mt-0">
								<div className="thead">
									<div className="tr">
										<div className="th span6">ชื่อ</div>
										<div className="th span2">สถานะ</div>
										<div className="th span3">หมวดหมู่ / ยี่ห้อ</div>
										<div className="th span5">วันบันทึก/แก้ไข</div>
									</div>
								</div>
								<div className="tbody">
									{
										this.state.is_loading
											? <div className="tr">
												<div className="td center aligned" data-info="nodata">
													<div className="ui active centered inline small loader"/>
												</div>
											</div>
											: null
									}
									{
										!this.state.is_loading
										&& this.state.products.length === 0
										&& (
											!window.Global.getAllQueryStrings().page
											|| window.Global.getAllQueryStrings().page === '1'
										) ?
											<div className="tr">
												<div className="td span16" style={{textAlign: 'center'}}>ไม่พบข้อมูล</div>
											</div>
											: null
									}
									{
										!this.state.is_loading
										&& this.state.products.length > 0 ?
											this.state.products.map((product, product_i) => {
												return (
													<Link to={"/v2/products/" + product.id}
													      className="tr"
													      key={product_i}
													      onClick={(e) => {
														      if (window.$(e.target).closest('.link').length !== 0) {
															      e.preventDefault()
															      return false
														      }
													      }}
													>
														<div className="td span6">
															<div>
																<div className="flex row thumb_img">
																	<img src={product.product_image_file_upload.url}
																	     className={'!w-20 !h-20 shrink-0'}
																	     alt={product.name}/>
																	<div className={'shrink'}>
																		<div className={'flex gap-1'}>
																			<div className={'font-bold'}>
																				{product.name}
																			</div>
																			<div>
																				{product.code}
																			</div>
																			{
																				product.is_not_count_stock
																					?
																					<div>
																						<i className="close icon red"
																						   style={{width: 'initial'}}/> ไม่นับสต๊อก
																					</div>
																					:
																					<div>
																						<i className="check icon green"
																						   style={{width: 'initial'}}/> นับสต๊อก
																					</div>
																			}
																			<div>
																				{
																					product.tags.map((tag, tag_i) => {
																						return (<span className={"ui label"}
																						              key={tag_i}>{tag}</span>);
																					})
																				}
																			</div>
																		</div>
																		{
																			product.is_draft === 1
																			&&
																			<div className={"flex row middle-xs"}>
																					<span
																						className="ui yellow empty circular label"/>&nbsp;ฉบับร่างรออนุมัติ
																			</div>
																		}
																		{
																			product.is_deleted === 1
																			&&
																			<div className={"flex row middle-xs"}>
																					<span
																						className="ui red empty circular label"/>&nbsp;ยกเลิก
																			</div>
																		}
																	</div>
																</div>
															</div>
														</div>
														<div className="td span2">
															<div className={'flex gap-2'}>
																<div className="flex row middle-xs">
																	{
																		product.is_saleable ?
																			<i className="green check circle outline icon large"/>
																			:
																			<i className="red times circle outline icon large"/>
																	} ขาย
																</div>
																<div className="flex row middle-xs">
																	{
																		product.is_purchasable ?
																			<i className="green check circle outline icon large"/>
																			:
																			<i className="red times circle outline icon large"/>
																	} ซื้อ
																</div>
															</div>
														</div>
														<div className="td span3">
															<div>
																<div>
																	{
																		product.category.map((category, category_i) => {
																			return (<span className={"ui label"}
																			              key={category_i}>{category}</span>);
																		})
																	}
																</div>
																<div>
																	{
																		product.brand.map((_brand, _brand_i) => {
																			return (<span className={"ui label"}
																			              key={_brand_i}>{_brand}</span>);
																		})
																	}
																</div>
																<div>
																	<div className="link"
																	     onClick={(e) => {
																		     this.props.history.push("/v2/shipments?has_product_ids=" + product.id + "&order_by=done_date_desc");
																	     }}
																	>
																		ดูประวัติล่าสุด
																	</div>
																	<div className="link"
																	     onClick={() => {
																		     window.Global.reactToDom(
																			     window.$('body'),
																			     <ShipmentProductAudit
																				     product={product}
																			     />
																		     );
																	     }}
																	>
																		ตรวจสอบสินค้า
																	</div>
																</div>
															</div>
														</div>
														<div className="td span5">
															{
																product.is_monthly_payment ?
																	<div>
																		<i className="check icon green"
																		   style={{width: 'initial'}}/>&nbsp;สัญญารายเดือน
																	</div>
																	: null
															}
															{
																product.is_serial_number ?
																	<div>
																		<i className="check icon green"
																		   style={{width: 'initial'}}/>&nbsp;Serial Number
																	</div>
																	: null
															}
															{
																product.is_expense ?
																	<div>
																		<i className="check icon green"
																		   style={{width: 'initial'}}/>&nbsp;ค่าใช้จ่าย
																	</div>
																	: null
															}
															{
																this.context.app.user
																&& this.context.app.user.user_permission.is_role_audit === 1
																&&
																<div>
																	{
																		product.product_chart_of_account
																		&&
																		product.product_chart_of_account.map((product_chart_of_account, i) => {
																			return (
																				<div key={i}
																				     className={'rounded-md bg-gray-50 p-2 border border-gray-200 hover:bg-gray-100 cursor-pointer flex flex-row wrap mt-1'}
																				     onClick={(e) => {
																					     e.preventDefault()
																					     window.Global.reactToDom(
																						     window.$('body'),
																						     <ProductChartOfAccountManage
																							     mode={'edit'}
																							     product={product}
																							     product_chart_of_account={product_chart_of_account}
																							     onEdited={(response) => {
																								     let x = [...this.state.products]
																								     x[product_i] = response.product

																								     this.setState({
																									     ...this.state,
																									     products: x
																								     })
																							     }}
																							     onDeleted={(response) => {
																								     let x = [...this.state.products]
																								     x[product_i] = response.product

																								     this.setState({
																									     ...this.state,
																									     products: x
																								     })
																							     }}
																						     />
																					     );
																				     }}
																				>
																					<div className={'mr-2'}>
																						<div>
																							{product_chart_of_account.event2}
																						</div>
																						{
																							product_chart_of_account.is_vat
																								?
																								<div
																									className={'inline-flex rounded bg-green-500 text-white p-0.5 text-xs'}>vat</div>
																								: null
																						}
																					</div>
																					<div className={''}>
																						<b>{product_chart_of_account.code}</b> : {product_chart_of_account.title}
																					</div>
																				</div>
																			)
																		})}

																	<div
																		className={'inline-flex rounded-md bg-gray-50 p-2 text-xs border border-gray-200 hover:bg-gray-100 cursor-pointer mt-1'}
																		onClick={(e) => {
																			e.preventDefault()
																			window.Global.reactToDom(
																				window.$('body'),
																				<ProductChartOfAccountManage
																					mode={'create'}
																					product={product}
																					product_chart_of_account={{
																						is_vat: 2,
																						event: 'purchase_order',
																						product_id: product.id,
																					}}
																					onCreated={(response) => {
																						let x = [...this.state.products]
																						x[product_i] = response.product

																						this.setState({
																							...this.state,
																							products: x
																						})
																					}}
																				/>
																			);
																		}}
																	>ผูกผังบัญชี
																	</div>
																</div>
															}
															{
																product.updated_user
																	?
																	<div data-tooltip={'แก้ไขล่าสุดโดย'}
																	     data-inverted=""
																	     data-position="top left">
																		{product.updated_user.name} · {window.Global.getDateThai(product.date_updated)}
																	</div>
																	: null
															}
															{
																product.created_user
																	?
																	<div data-tooltip={'บันทึกโดย'}
																	     data-inverted=""
																	     data-position="top left"
																	>
																		{product.created_user.name} · {window.Global.getDateThai(product.date_created)}
																	</div>
																	: null
															}
														</div>
													</Link>
												)
											}) : null
									}
								</div>
							</div>
						}
					/>
				}
			</div>
		)
	}

	render() {
		if (this.state.mode === 'list') {
			return this.renderList();
		}
		if (this.state.is_loading) {
			return <div className="ui active centered inline loader"/>
		}
		if (this.state.mode === 'view') {
			return this.renderView();
		}
		// console.log(this.state.product);
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
			     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     className="main ui container">
				<div id="HeaderTop_root" className="flex row wrap" style={{marginBottom: '1rem'}}>
					<div className="flex row middle-xs center-xs">
						<div className="ui huge breadcrumb" style={{margin: '0 1em 0 0'}}>
							<Link className="active section" to="/v2/products">สินค้า</Link>
							{
								this.state.product ?
									<>
										<span className="divider" style={{margin: '0px 1rem'}}>/</span>
										<Link className="section" to={"/v2/products/" + this.state.product.id}>
											{this.state.product.name} {this.state.product.code ? <>({this.state.product.code})</> : null}
										</Link>
									</>
									: null
							}
							<span className="divider" style={{margin: '0px 1rem'}}>/</span>
							<div className={"section"}>
								{this.state.mode === 'edit' ? "แก้ไข" : null}
								{this.state.mode === 'create' ? "เพิ่ม" : null}
							</div>
						</div>
					</div>
				</div>

				<div id="Product_editRoot">
					<div className="ui tall stacked segment loading" style={{marginTop: 0}}>
						<form className="ui form" autoComplete="off">
							<div className="ui grid">
								<div className="doubling two column row">
									<div className="column">
										<h4 className="ui dividing header">รายละเอียด</h4>
										<div className="two fields">
											<div className="field required">
												<label>ชื่อสินค้าและบริการ</label>
												<input type={"text"}
												       name={"name"}
												       defaultValue={this.state.product.name || ''}
												/>
											</div>
											<div className="field">
												<label>ชื่อสินค้าภาษาอังกฤษ</label>
												<input type="text"
												       name="name_en"
												       defaultValue={this.state.product.name_en || ''}
												/>
											</div>
										</div>
										<div className={'ui yellow message mini'}>
											<b>ชื่อที่สงวนไว้ : </b>&nbsp;&nbsp;&nbsp;เงินเดือน, เงินเดือนกรรมการ, ค่าแรง/วัน,
											ประกันสังคม, เบิกเงินล่วงหน้า
										</div>
										<div className="two fields">
											<div className="field">
												<label>ชื่อบนเอกสาร <span data-inverted=""
												                          data-position="top left"
												                          data-tooltip="ชื่อบนเอกสารให้ระบุ : ในกรณีต้องการแสดงชื่อนี้แทนชื่อสินค้าปกติ ตอนพิมพ์บิลเอกสาร"><i
													className="info circle icon"></i></span></label>
												<input type="text" name="name_on_document"
												       defaultValue={this.state.product.name_on_document || ''}/>
											</div>
											<div className="field">
												<label>สี</label>
												<div className={"color-picker"}/>
												<input type="hidden" name="color_hex"
												       defaultValue={this.state.product.color_hex}/>
											</div>
										</div>
										<div className="two fields">
											<div className="field">
												<label>รูปสินค้า</label>
												<Form2FileUpload
													upload_type="single_image"
													input_name="image_filename"
													removeInputName="image_filename"
													isCanRemove={true}
													value={this.state.product && this.state.product.file_upload ? this.state.product.file_upload.filename : ''}
													image_url={this.state.product && this.state.product.file_upload ? this.state.product.file_upload.url : ''}
													key_file_data="file_upload"
													width="110px"
													height="110px"
													mode={"view"}
													url={process.env.REACT_APP_DOMAIN + "/api/file/upload?type=upload"}
													// onRemove={this.state.signature && this.state.signature.file_upload ? () => {
													// 	return false;
													// } : false}
													onUploadDone={(file) => {
														// console.log(file);
														return true;
													}}
												/>
											</div>
											<div className="field">
												{/*<div className="field required custom-running-number">*/}
												{/*	<label className="flex row">*/}
												{/*		รหัสสินค้า&nbsp;*/}
												{/*		<span className="ui checkbox" data-form2_setup="done"*/}
												{/*		      data-state="create">*/}
												{/*                  <input type="checkbox" tabIndex="-1" className="hidden"*/}
												{/*                         name="is_code_generate_auto"*/}
												{/*                         defaultChecked={"checked"}/>*/}
												{/*                  <label htmlFor="is_code_generate_auto">Auto</label>*/}
												{/*              </span>*/}
												{/*	</label>*/}
												{/*	<input type="text" name="code"/>*/}
												{/*</div>*/}
												<div id="is-code-generate-auto" className="column field"/>


											</div>
										</div>

										<div className="bg-[#fff8db] p-5">
											<label htmlFor="is_not_count_stock">
												<b>ประเภทสินค้า</b>: <span
												style={{color: 'red'}}><u>สำคัญ</u> แก้ไขภายหลังไม่ได้</span>
											</label>
											<div id="is_not_count_stock"
											     className="flex flex-row flex-wrap mt-4">
												<div className="ml-5 mr-6">
													<div className="ui radio checkbox"
													     data-form2_setup="true">
														<input type="radio"
														       name="is_not_count_stock"
														       value="0"
														       readOnly={this.state.mode === 'edit'}
														       className="hidden"
														/>
														<label>นับสต๊อก</label>
													</div>
												</div>
												<div>
													<div className="ui radio checkbox"
													     data-form2_setup="true">
														<input type="radio"
														       name="is_not_count_stock"
														       value="1"
														       readOnly={this.state.mode === 'edit'}
														       className="hidden"
														/>
														<label><u>ไม่</u>นับสต๊อก (เช่น งานบริการ / ค่าใช้จ่าย)</label>
													</div>
												</div>
											</div>
										</div>
										<div className="mt-4" data-is_monthly_payment="0">
											<div
												className={this.state.mode === 'edit' ? "ui checkbox disabled" : "ui checkbox"}>
												<input type="checkbox" tabIndex="0" name="is_serial_number"
												       className="hidden" value="0"/>
												<label>สินค้ามี Serial Number <span
													style={{color: 'red'}}>(แก้ไขภายหลังไม่ได้)</span></label>
											</div>
										</div>
										{/*<div className="mt-6">*/}
										{/*	<div*/}
										{/*		className={this.state.mode === 'edit' ? "ui checkbox disabled" : "ui checkbox"}>*/}
										{/*		<input type="checkbox"*/}
										{/*		       tabIndex="0"*/}
										{/*		       name="is_not_count_stock"*/}
										{/*		       data-change=""*/}
										{/*		       className="hidden" value="0"*/}
										{/*		/>*/}
										{/*		<label>ไม่นับสต๊อก (บริการ)</label>*/}
										{/*	</div>*/}
										{/*</div>*/}
										<div className="mt-4">
											<div className="ui checkbox"
											     ref={(ref) => {
												     window.$(ref).checkbox();
											     }}
											>
												<input type="checkbox" name="is_expense" value="1"/>
												<label>เป็นรายได้พนักงาน (ออกสลิปเงินเดือน) / ค่าใช้จ่ายเกี่ยวกับพนักงาน</label>
											</div>
										</div>
										<div className="mt-4">
											<div
												className={this.state.mode === 'edit' ? "ui checkbox disabled" : "ui checkbox"}>
												<input id="is_monthly_payment"
												       type="checkbox"
												       tabIndex="0"
												       name="is_monthly_payment"
												       data-change=""
												       className="hidden"
												       value="0"
												/>
												<label htmlFor="is_monthly_payment">สัญญารายเดือน <span
													style={{color: 'red'}}>(แก้ไขภายหลังไม่ได้)</span></label>
											</div>
										</div>
										{
											this.state.mode === 'create' ?
												<div className="box mt-4 mb-5" data-state="create">
													<div className="flex row middle-xs">
							                    <span className="ui checkbox">
							                        <input id="is_bom" type="checkbox" tabIndex="0" name="is_bom"
							                               data-change="" className="hidden"/>
							                        <label htmlFor="is_bom">เป็นสินค้าประกอบชุด</label>
							                    </span>
													</div>
													<div className="field" data-is_bom="1" style={{display: 'none'}}>
														<div className="ProductListBom_root"
														     style={{marginTop: '2rem'}}/>
														<div style={{textAlign: 'right', margin: '10px 0 0 0'}}>
															<div
																className="ui button ProductListBom_newButton">เพิ่มรายการประกอบสินค้าชุด
															</div>
														</div>
													</div>
												</div>

												: null
										}
										<div className="two fields" style={{marginTop: '2rem'}}>
											<div className="field">
												<label>หมวดหมู่สินค้า</label>
												<select name="category"
												        className={"ui search dropdown selection multiple"}
												        multiple={true}/>
											</div>
											<div className="field">
												<label>ยี่ห้อ</label>
												<select name="brand"
												        className="ui search dropdown selection multiple"
												        multiple={true}/>
											</div>
										</div>
										<div className="field">
											<label>คำอธิบายสินค้า</label>
											<textarea name="description"
											          defaultValue={this.state.product.description || ''}/>
										</div>
										<div className="field">
											<label>ตัวช่วยกรอกรายละเอียดสินค้าตอนสร้างใบขายสินค้า</label>
											<textarea name="default_description"
											          style={{minHeight: '5rem'}}
											          defaultValue={this.state.product.default_description || ''}/>
										</div>
										<div className="field">
											<label>Tags</label>
											<select name="tags"
											        className="ui search dropdown selection multiple"
											        multiple={true}
											/>
										</div>
										<div className="inline field">
											<div className="ui checkbox"
											     ref={(ref) => {
												     window.$(ref).checkbox();
											     }}
											>
												<input type="checkbox" tabIndex="0" className="hidden"
												       defaultChecked={this.state.mode === 'create'}
												       name="is_saleable" value="1"/>
												<label>อนุญาตขาย</label>
											</div>
										</div>
										<div className="inline field">
											<div className="ui checkbox"
											     ref={(ref) => {
												     window.$(ref).checkbox();
											     }}
											>
												<input type="checkbox" tabIndex="0" className="hidden"
												       defaultChecked={this.state.mode === 'create'}
												       name="is_purchasable" value="1"/>
												<label>อนุญาตซื้อ</label>
											</div>
										</div>
									</div>
									<div className="column">
										<div style={{
											padding: '1em',
											backgroundColor: '#f5f5f5',
											margin: '0 0 0.5rem 0'
										}}>
											<div className="flex row">
												<div className="">
													<div className={'text-lg font-bold'}>กำหนดหน่วยนับและราคา</div>
													<div style={{margin: 0}}>
														<span style={{color: 'red'}}><b>อัตราส่วน</b> แก้ไขภายหลังไม่ได้</span>
													</div>
												</div>
											</div>
											<div className={'ui divider'}></div>
											<div className="field">
												<div className="ProductListUom_root"
												     ref={(ref) => {
													     this.ProductListUom_root = window.$(ref);
												     }}
												>
													{
														this.state.product
														&& this.state.product.sell_price ?
															this.state.product.sell_price.map((sell_price, sell_price_i) => {
																return (
																	<ProducUomItem
																		key={sell_price_i}
																		index={sell_price_i}
																		sell_price={sell_price}
																		mode={"edit"}
																	/>
																);
															})
															: null
													}
													{
														!this.state.product
														|| (this.state.product && this.state.product.sell_price.length === 0) ?
															<div data-nodata=""
															     style={{
																     padding: '1.5rem',
																     opacity: 0.6,
																     textAlign: 'center'
															     }}
															>
																ไม่ได้กำหนดหน่วยนับ
															</div>
															: null
													}

												</div>
												<div className="row middle-xs center-xs">
													<div
														className="ui button positive ProductListUom_newButton"
														onClick={() => {
															let ratio = '';
															if (this.ProductListUom_root.find('.ProductSellPrice_list').length === 0) {
																ratio = 1;
															}
															this.ProductListUom_root.find('div[data-nodata]').remove();
															// สร้างหน่วยนับใหม่
															let $e2 = this.getProductPrice(this.$parent.find('form'), {
																unit_name: '',
																ratio: ratio
															});
															this.ProductListUom_root.append($e2);
															$e2.find('input[name="sell_price[][unit_name]"]').focus();
														}}
													>
														เพิ่มหน่วยนับ
													</div>
												</div>
											</div>
										</div>
										<div className="field" data-state="create">
											<label>ตัวช่วยสร้างหน่วยนับจาก <a
												href={process.env.REACT_APP_DOMAIN + "/setting/uom"}
												rel="noopener noreferrer" target='_blank'>
												UOM
											</a>
												<div id="refresh-uom-button"
												     className="link" style={{position: 'absolute', right: '1rem'}}
												>
													ดึงข้อมูลล่าสุด
												</div>
											</label>
											<select name="uom_id" className="ui dropdown selection" tabIndex="0">
												<option value={"null"}>ไม่ระบุ</option>
											</select>
										</div>
										<h4 className="ui dividing header">อื่นๆ</h4>
										<div className="field">
											<label>ซื้อสินค้าจากเจ้าหนี้</label>
											<input type="hidden" name="default_supplier_id" value=""/>
										</div>
										<div className="two fields">
											<div className="field">
												<label>หน่วยนับขาย</label>
												<select className="ui dropdown selection"
												        name="default_sell_unit_type_index"
												>
													<option value="null">ไม่เลือก</option>
													{
														this.state.product
														&& this.state.product.sell_price ?
															this.state.product.sell_price.map((sell_price, sell_price_i) => (
																<option key={sell_price_i}
																        value={sell_price_i}>{sell_price.unit_name}</option>
															))
															: null
													}
												</select>
											</div>
											<div className="field">
												<label>หน่วยนับซื้อ</label>
												<select className="ui dropdown selection"
												        name="default_buy_unit_type_index"
												        defaultValue={this.state.product.default_buy_unit_type_index !== undefined ? this.state.product.default_buy_unit_type_index : 'null'}
												>
													<option value="null">ไม่เลือก</option>
													{
														this.state.product
														&& this.state.product.sell_price ?
															this.state.product.sell_price.map((sell_price, sell_price_i) => (
																<option key={sell_price_i}
																        value={sell_price_i}>{sell_price.unit_name}</option>
															))
															: null
													}
												</select>
											</div>
										</div>
										{
											this.state.mode === 'create'
												?
												<div id="initial-stock"
												     className="field"
												     data-state="create"
												     style={{
													     marginTop: '2rem',
													     backgroundColor: 'rgb(255, 248, 219)',
													     padding: '1rem'
												     }}
												>
													<h4 className="ui dividing header">ยอดยกมา
														(จำนวนสินค้าจากระบบเดิม)</h4>

													<div className="two fields">
														<div className="field">
															<label>จำนวนสินค้าที่ยกมา</label>
															<div className="ui right labeled input">
																<input type="number" placeholder="จำนวน"
																       name="initial_stock_on_hand2"/>
																<input type="hidden"
																       name="initial_stock_on_hand"
																       className="ui dropdown label"
																       value="0"/>
																<div id="initial_stock_on_hand_dropdown"
																     className="ui dropdown label"
																     data-name="initial_stock_on_hand_dropdown"
																     tabIndex="0">
																	<div className="text"/>
																	<i className="dropdown icon"/>
																	<div className="menu transition hidden"
																	     tabIndex="-1">
																	</div>
																</div>
															</div>
														</div>
														<div className="field">
															<label>ราคาทุนต่อหน่วย</label>
															<div className="ui right labeled input">
																<input type="number" placeholder="ราคา"
																       name="initial_cost_price_per_unit"
																       data-clean-number=""
																       data-decimal="true"/>
																<div className="ui label">฿</div>
															</div>
														</div>
													</div>
													<div className="two fields">
														<div className="field">
															<label>กำหนดคลังสินค้าของสินค้าที่ยกมา</label>
															<input type="text"
															       name="initial_stock_location_id"
															/>
														</div>
														<div className="field">
															<label>วันที่ที่ยกมา</label>
															<div data-form_calendar="date"
															     data-input_name="initial_stock_date"
															     data-placeholder={"วันที่ที่ยกมา"}
															     data-locale="th"
															/>
														</div>
													</div>
												</div>
												: null
										}
										<div className="field">
											<label>ไฟล์แนบ</label>
											<div id="Upload_fileRoot"
											     data-form2_setup="done" data-form2_type="upload"
											     data-input_name="product_file_upload"
											     data-remove_input_name="remove_file_upload"
											     data-is_can_remove="true"
											/>
										</div>
									</div>
								</div>
								<div className="column row">
									<div className="column">
										<div className="ui error message"/>
										<div className="flex row">
											{
												this.state.mode === 'edit' ?
													<>
														<input type="hidden" name={"product_id"}
														       defaultValue={this.state.product.id}/>
													</>
													: null
											}
											<input type="hidden" name={"is_draft"}
											       defaultValue={this.state.product ? this.state.product.is_draft : 0}/>
											<input type="hidden" name={"tax_type"}
											       defaultValue={"has_vat"}/>
											<button className="ui red button" type="button"
											        onClick={() => {
												        this.void(
													        process.env.REACT_APP_DOMAIN + '/api/product',
													        {product_id: this.state.product.id},
													        {
														        onSuccess: () => {
															        this.props.history.push({
																        pathname: '/v2/products/' + this.state.product.id,
																        state: null,
															        });
														        }
													        }
												        );
											        }}
											>ลบ
											</button>
											<div className="right floated">
												<Link id="cancelButton"
												      to={this.state.mode === 'edit' ? "/v2/products/" + this.state.product.id : "/v2/products/"}
												      className="ui button"
												      data-no_navigo="">ยกเลิก</Link>
												{
													this.state.mode === 'create' ?
														<button id="draft-button"
														        className="ui button"
														        type="button"
														        onClick={() => {
															        window.$('*[name="is_draft"]').val(1);
															        if (window.$('#draft-button').hasClass('loading')) {
																        return null;
															        }
															        this.$parent.find('form').trigger('submit');
														        }}
														        data-state="create">ฉบับร่าง
														</button>
														: null
												}
												<button id="submit-button"
												        className="ui primary button"
												        type="submit">บันทึกข้อมูล
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}

	void(url, _data, options) {
		window.Global.confirm({
			title: options && options.title ? options.title : 'ยืนยันลบข้อมูล',
			content: '<form class="ui form">\n\t<p>โปรดยืนยันลบข้อมูล การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n\t<div class="ui error message"></div>\n</form>',
			cancel_text: 'ไม่ดำเนินการ',
			approve_text: 'ลบข้อมูล',
			onShowToSetupForm: ($modal) => {
				$modal.find('form').form2('setup');
				$modal.find('form').form2('submit', {
					method: 'DELETE',
					url: url,
					loadingButton: $modal.find('.button.approve'),
					beforeSent: (data) => {
						data = _data;
						return data;
					},
					onSuccess: (response) => {
						$modal.modal('hide');
						window.Global.messageTop({
							type: 'positive',
							message: 'ลบข้อมูลสำเร็จ'
						});
						if (options.onSuccess) {
							options.onSuccess(response);
						}
						//this.props.onEditedSuccess(response);
						// this.setState({
						//    product_display: {...response.product_display}
						// });
					}
				});
			}
		});
	}
}

// Products.contextType = AppContext

export class ProductsMenu extends React.Component {
	render() {
		return (
			<div className="ui menu flex row wrap middle-xs Setting_menu">
				{
					this.props.product_id ?
						<>
							<Link className={this.props.index === 0 ? "item active" : "item"}
							      to={"/v2/products/" + this.props.product_id}>ข้อมูล</Link>
							<Link className={this.props.index === 1 ? "item active" : "item"}
							      to={"/v2/products/" + this.props.product_id + "/stock"}>คลังสินค้า</Link>
							<Link className={this.props.index === 2 ? "item active" : "item"}
							      to={"/v2/products/" + this.props.product_id + "/barcode"}>บาร์โคด</Link>
							<Link className={this.props.index === 3 ? "item active" : "item"}
							      to={"/v2/products/" + this.props.product_id + "/serial-number"}>Serial Number</Link>
							<Link className={this.props.index === 4 ? "item active" : "item"}
							      to={"/v2/products/" + this.props.product_id + "/chart_of_account"}>บันทึกบัญชี</Link>
							{
								this.props.search_barcode ?
									<form id="SearchProductBarcode_root"
									      className="right floated flex row center align"
									      style={{paddingRight: '0.8em'}}
									      onSubmit={(e) => {
										      e.preventDefault();
										      let obj = window.$(e.target).serializeObject();
										      if (!obj.page) {
											      obj.page = 1
										      }
										      this.props.onSearchSubmit(obj)
									      }}
									>
										<div className="ui transparent icon input">
											<input type="text" name="search_barcode"
											       placeholder="ค้นหาบาร์โคด"
											       defaultValue={this.props.barcode_input_value || ""}
											/>
											<i className="search icon"/>
										</div>
									</form>
									: null
							}
							{
								this.props.search_serial_number ?
									<form id="SearchProductSerialNumber_root"
									      className="right floated flex row center align"
									      style={{paddingRight: '0.8em'}}

									      onSubmit={(e) => {
										      e.preventDefault();
										      let obj = window.$(e.target).serializeObject();
										      if (!obj.page) {
											      obj.page = 1
										      }
										      this.props.onSearchSubmit(obj)
									      }}
									>
										<div className="ui transparent icon input" style={{width: 250}}>
											<input type="text" name="search_serial_number"
											       placeholder="ค้นหา Serial Number / เลขที่ใบสั่งซื้อ"
											       defaultValue={this.props.serial_number_input_value || ""}
											/>
											<i className="search icon"/>
										</div>
									</form>
									: null
							}
						</>
						: <div className="ui active centered inline small loader"/>
				}

			</div>
		);
	}
}

class ProductBomAdjustmentCostTemplate extends React.Component {
	render() {
		return (
			<div id="template-product_bom_adjustment_cost">
				<div className="ui modal tiny">
					<div className="header">ต้นทุนการผลิตสินค้า</div>
					<div className="content">
						<form className="ui form" autoComplete="off">
							<div className="two fields">
								<div className="field">
									<label>สินค้าหลัก</label>
									<p>{this.props.product.name || '-'}</p>
								</div>
								<div className="field required">
									<label>หน่วยนับ</label>

									<div id="unitPriceDropdown"/>
								</div>
							</div>
							<div className="two fields">
								<div className="field required">
									<label>สินค้าต้นทุน</label>
									<input type="text" name="cost_product_id"/>
								</div>
								<div className="field required">
									<label>หน่วยนับ</label>

									<div id="unitPriceDropdown2"/>
								</div>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="ui red button" style={{display: 'none'}}>ลบ</div>
							<div className="right floated">
								<div className="ui cancel button">ยกเลิก</div>
								<div className="ui green approve button">ตกลง</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

class ManageProductSellPriceDiscount extends React.Component {
	render() {
		return (
			<div id="template-manage-product-sell-price-discount">
				<div className="ui modal tiny">
					<div className="header">ขั้นบันไดราคาขายสินค้า</div>
					<div className="content">
						<form className="ui form" autoComplete="off">
							<div className="field">
								<label>จำนวนตั้งแต่</label>

								<div id="unitPriceDropdown"/>
							</div>
							<div className="field">
								<label>จำนวนสูงสุด</label>

								<div id="unitPriceDropdown2" className="Table_column flex row center align span2 half">
									<div className="ui right action left input">
										<input type="text" name="product_price_condition_stair_step[maximum__quantity]"
										       placeholder="จำนวน" defaultValue="1"/>
										<div className="ui basic floating dropdown button Item_selectUnitName">
											<div className="text">-</div>
											<div className="menu"/>
										</div>
										<input type="hidden"
										       name="product_price_condition_stair_step[maximum_quantity]"/>
									</div>
								</div>
							</div>
							<div className="field">
								<label>ราคาใหม่</label>
								<div className="ui right labeled input">
									<input type="number" name="price"/>
									<div className="ui basic label">บาท</div>
								</div>
							</div>
							<div className="field">
								<label>ส่วนลด</label>
								<div className="ui right action left input">
									<input type="text" name="discount" placeholder="ส่วนลด" defaultValue="0"/>
									<div className="ui basic floating dropdown button Item_selectUnitNameDiscount">
										<div className="text">฿</div>
										<div className="menu">
											<div data-value="฿" data-index="0" className="item">฿</div>
											<div data-value="%" data-index="0" className="item">%</div>
										</div>
									</div>
									<input type="hidden" name="discount_type" value="฿"/>
								</div>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="ui red button" style={{display: 'none'}}>ลบ</div>
							<div className="right floated">
								<div className="ui cancel button">ยกเลิก</div>
								<div className="ui green approve button">ตกลง</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

class ProductGalleryFileUpload extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			mode: this.props.mode,
			product: this.props.product,
			product_gallery_file_uploads: this.props.product.product_gallery_file_upload,
		};
		this.state.product_gallery_file_uploads.push({})
	}

	prepare() {

	}

	fetch() {

	}

	view() {

	}

	edit() {

	}

	create() {

	}

	componentDidMount() {
		if (this.state.mode === 'list') {
			this.fetch();
		}
	}

	renderList() {
		return (
			<div style={{margin: '2rem 0 0 0'}}
			     ref={(ref) => {
				     this.$parent = ref;
			     }}>
				<h4 className="ui dividing header">รูปสินค้า</h4>
				<form className="flex row wrap">
					{
						this.state.product_gallery_file_uploads.map((product_gallery_file_upload, i) => {
							if (!product_gallery_file_upload.id) {
								return (
									<div key={i}>
										<Form2FileUpload
											upload_type="single_image"
											input_name="image_filename"
											key_file_data="file_upload"
											width="110px"
											height="110px"
											url={process.env.REACT_APP_DOMAIN + '/api/file/upload?type=upload'}
											onImageUploadSuccess={(file) => {
												window.Global.ajax({
													method: 'POST',
													url: process.env.REACT_APP_DOMAIN + '/api/product/gallery',
													data: {
														product_id: this.state.product.id,
														filename: file.name,
														original_filename: file['originalFilename'],
													},
													done: (response) => {
														if (!response.success) {
															return false;
														}

														let product_gallery_file_upload = response.product.product_gallery_file_upload;
														product_gallery_file_upload.push({});

														this.setState({
															product_gallery_file_uploads: product_gallery_file_upload
														});
													}
												});
											}}
										/>
									</div>
								)
							}
							return (
								<div key={i}
								     className=''>
									<Form2FileUpload
										upload_type="single_image"
										input_name="image_filename"
										key_file_data="file_upload"
										width="110px"
										height="110px"
										value={product_gallery_file_upload.filename}
										image_url={product_gallery_file_upload.file_upload.url}
										url={process.env.REACT_APP_DOMAIN + '/api/file/upload?type=upload'}
										onImageUploadSuccess={(file) => {
											window.Global.ajax({
												method: 'PUT',
												url: process.env.REACT_APP_DOMAIN + '/api/product/gallery',
												data: {
													product_gallery_file_upload_id: product_gallery_file_upload.id,
													filename: file.name,
													original_filename: file['originalFilename'],
												},
												done: (response) => {
													if (!response.success) {
														return false;
													}
													let product_gallery_file_uploads = [...this.state.product_gallery_file_uploads];
													product_gallery_file_uploads[i] = response.product_gallery_file_upload;
													this.setState({
														product_gallery_file_uploads: product_gallery_file_uploads
													});
												}
											});
										}}
										onRemove={() => {
											window.Global.confirm({
												title: 'ยืนยันลบข้อมูล',
												content: '<form class="ui form">\n\t<p>โปรดยืนยันลบข้อมูล การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n\t<div class="ui error message"></div>\n</form>',
												cancel_text: 'ยกเลิก',
												approve_text: 'ตกลง',
												onShowToSetupForm: ($modal) => {
													$modal.find('form').form2('setup');
													$modal.find('form').form2('submit', {
														method: 'DELETE',
														url: process.env.REACT_APP_DOMAIN + '/api/product/gallery',
														loadingButton: $modal.find('.button.approve'),
														beforeSent: (data) => {
															data.product_gallery_file_upload_id = product_gallery_file_upload.id;
															return data;
														},
														onSuccess: () => {
															$modal.modal('hide');
															window.Global.messageTop({
																type: 'positive',
																message: 'ลบเรียบร้อย'
															});

															let product_gallery_file_uploads = [...this.state.product_gallery_file_uploads];
															product_gallery_file_uploads.splice(i, 1);
															this.setState({
																product_gallery_file_uploads: product_gallery_file_uploads
															});
														}
													});
												}
											});
										}}
									/>
								</div>
							);
						})
					}
				</form>
			</div>
		);
	}

	render() {
		if (this.state.mode === 'list') return this.renderList();

		return null;
	}

	void() {

	}
}

class ProductPriceCondition extends React.Component {
	render() {
		// console.log(this.props.product);
		// console.log(this.props.product_price_condition);
		return (
			<div>
				<Modal className="ui modal tiny"
				       closable={false}
				       onShowToSetupForm={($modal) => {
					       let $payment_by = $modal.find('input[name="payment_by[]"]');
					       $payment_by.explorer({
						       url: process.env.REACT_APP_DOMAIN + '/api/payment_by',
						       additionalData: () => {
							       return {
								       type: 'credit_card_by_bangkok_bank_iplay_paygate'
							       }
						       },
						       multiple: true,
						       key: 'payment_by',
						       template: {
							       list: function (value) {
								       return window.Handlebars.compile('<div class="item">\n    <div class="flex">\n        <div><b>{{name}}</b></div>\n    </div>\n</div>')(value);
							       },
							       selected: {
								       text: 'name',
								       value: 'id',
								       placeholder: 'เลือกวิธีชำระเงิน'
							       }
						       },
						       exclude: {
							       sentKeyData: 'id',
							       key: 'id'
						       }
					       });

					       if (this.props.mode === 'create') {
						       // $modal.find('form').form2('setup');
						       $modal.find('form').form2('setup', {
							       'is_relationship_group_onChange': (is_relationship_group) => {
								       if (is_relationship_group === '1') {
									       $modal.find('form').find('#relationship').hide();
									       $modal.find('form').find('#relationship_group').show();
									       $modal.find('form').find('.Explorer[data-explorer_input_name="relationship_id[]"]').explorer('clear');
									       setTimeout(() => {
										       $modal.find('form').find('div[data-explorer_input_name="relationship_group_id[]"] input[name="search"]').focus();
									       }, 50);
								       }
								       if (is_relationship_group === '0') {
									       $modal.find('form').find('#relationship').show();
									       $modal.find('form').find('#relationship_group').hide();
									       $modal.find('form').find('.Explorer[data-explorer_input_name="relationship_group_id[]"]').explorer('clear');
									       setTimeout(() => {
										       $modal.find('form').find('div[data-explorer_input_name="relationship_id[]"] input[name="search"]').focus();
									       }, 50);
								       }
								       if (is_relationship_group === 'null') {
									       $modal.find('form').find('#relationship').hide();
									       $modal.find('form').find('#relationship_group').hide();

									       $modal.find('form').find('.Explorer[data-explorer_input_name="relationship_id[]"]').explorer('clear');
									       $modal.find('form').find('.Explorer[data-explorer_input_name="relationship_group_id[]"]').explorer('clear');
								       }
							       },
							       'is_only_payment_by_onChange': (is_only_payment_by) => {
								       $modal.find('#is_only_payment_by').css('display', is_only_payment_by ? 'flex' : 'none');
								       if (!is_only_payment_by) {
									       $payment_by.explorer('clear');
								       }
							       }
						       });

						       $modal.find('form').find('input[name="relationship_id[]"]').explorer({
							       url: process.env.REACT_APP_DOMAIN + '/api/relationship',
							       additionalData: {
								       limit: 30,
								       page: 1
							       },
							       key: 'relationship',
							       multiple: true,
							       template: {
								       list: function (product) {
									       return window.Handlebars.compile('<div class="item">\n\t<div class="flex row">\n\t\t<div>\n\t\t\t<b>{{name}}</b>\n\t\t</div>\n\t</div>\n</div>')(product);
								       },
								       selected: {
									       text: 'name',
									       value: 'id',
									       placeholder: 'เลือกคู่ค้า'
								       }
							       }
						       });

						       $modal.find('form').find('input[name="relationship_group_id[]"]').explorer({
							       url: process.env.REACT_APP_DOMAIN + '/api/relationship/group',
							       additionalData: {
								       limit: 30,
								       page: 1
							       },
							       key: 'relationship_group',
							       multiple: true,
							       template: {
								       list: function (relationship_group) {
									       return window.Handlebars.compile('<div class="item">\n\t<div class="flex row">\n\t\t<div>\n\t\t\t<b>{{name}}</b>\n\t\t</div>\n\t</div>\n</div>')(relationship_group);
								       },
								       selected: {
									       text: 'name',
									       value: 'id',
									       placeholder: 'เลือกกลุ่มคู่ค้า'
								       }
							       }
						       });

						       $modal.find('form').form2('submit', {
							       method: 'POST',
							       url: process.env.REACT_APP_DOMAIN + '/api/product_price_condition',
							       beforeSent: (object) => {
								       if (object.product_price_id !== 'all') {
									       let ratio = this.props.product.sell_price.filter((sell_price) => {
										       return parseFloat(sell_price.id) === parseFloat(object.product_price_id)
									       })[0];
									       object.ratio = ratio.ratio;
								       }
								       if (parseFloat(object.is_relationship_group)) {
									       delete object.relationship_id;
								       }
								       if (!parseFloat(object.is_relationship_group)
									       && parseFloat(object.is_relationship_group) !== undefined) {
									       delete object.relationship_group_id;
								       }
								       if (!parseFloat(object.is_relationship_group)
									       && parseFloat(object.is_relationship_group) === undefined) {
									       delete object.relationship_group_id;
									       delete object.relationship_id;
								       }
								       // delete object.is_relationship_group;
								       return object;
							       },
							       loadingButton: $modal.find('.button.approve'),
							       onSuccess: (response) => {
								       $modal.modal('hide');
								       window.Global.messageTop({
									       type: 'positive',
									       message: 'บันทึกข้อมูลเรียบร้อย'
								       });

								       this.props.CreateSuccess(response);
							       }
						       });
					       }
					       if (this.props.mode === 'edit') {
						       $modal.find('form').form2('setup', {
							       'is_only_payment_by_onChange': (is_only_payment_by) => {
								       $modal.find('#is_only_payment_by').css('display', is_only_payment_by ? 'flex' : 'none');
								       if (!is_only_payment_by) {
									       $payment_by.explorer('clear');
								       }
							       }
						       });
						       //this.prepare();

						       if (this.props.product_price_condition.product_price_condition_payment_by.length) {
							       $modal.find('form').find('input[name="is_only_payment_by"]')
								       .prop('checked', true)
								       .trigger('change');
							       window.$.each(this.props.product_price_condition.product_price_condition_payment_by, function (i, product_price_condition_payment_by) {
								       $modal.find('form').find('.Explorer[data-explorer_input_name="payment_by[]"]')
									       .explorer('set value', product_price_condition_payment_by['payment_by']);
							       });
						       }

						       $modal.find('form').form2('submit', {
							       method: 'PUT',
							       url: process.env.REACT_APP_DOMAIN + '/api/product_price_condition',
							       beforeSent: (object) => {
								       if (object.product_price_id !== 'all') {
									       let ratio = this.props.product.sell_price.filter((sell_price) => {
										       return parseFloat(sell_price.id) === parseFloat(object.product_price_id)
									       })[0];
									       object.ratio = ratio.ratio;
								       }
								       if (object.product_price_id === 'all') {
									       object.ratio = "";
								       }
								       return object;
							       },
							       loadingButton: $modal.find('.button.approve'),
							       onSuccess: (response) => {
								       $modal.modal('hide');
								       window.Global.messageTop({
									       type: 'positive',
									       message: 'บันทึกข้อมูลเรียบร้อย'
								       });
								       this.props.EditSuccess(response);
							       }
						       });
					       }
				       }}>
					<div className="header">
						<h2>
							{this.props.mode === 'edit' ? 'แก้ไข' : null}
							{this.props.mode === 'create' ? 'กำหนด' : null}
							ราคาพิเศษ
						</h2>
					</div>
					<div className="content">
						<form className="ui form">
							{
								this.props.mode === 'create' ?
									<>
										<input type="hidden"
										       name="product_id"
										       defaultValue={this.props.product.id}/>
										<input type="hidden"
										       name="type"
										       defaultValue={"custom"}/>
									</>
									: null
							}
							{
								this.props.mode === 'edit' ?
									<input type="hidden"
									       name="product_price_condition_id"
									       defaultValue={this.props.product_price_condition.id}/>
									: null
							}

							<div className="flex row wrap column one column computer padded">
								<div className="column field required">
									<label htmlFor="">หน่วยนับ</label>
									<select name={'product_price_id'}
									        ref={(ref) => {
										        window.$(ref).dropdown({
											        onChange: () => {
												        let product_price_id = window.$(ref).val();
												        let value = product_price_id;
												        let sell_price = this.props.product.sell_price.filter((_sell_price) => {
													        return parseFloat(_sell_price.id) === parseFloat(product_price_id)
												        })[0];
												        if (sell_price && sell_price.sell_price_1) {
													        value = sell_price.sell_price_1;
												        }
												        if (value === 'all') {
													        this.$priceField.hide();
												        }
												        if (value !== 'all') {
													        this.$priceField.show();
												        }
												        this.$inputPrice.val(value);
											        }
										        });
									        }}
									        defaultValue={
										        this.props.mode === 'edit' ?
											        this.props.product_price_condition.product_price_id ?
												        this.props.product_price_condition.product_price_id
												        : 'all'
											        : ''
									        }
									>
										{
											this.props.product
											&& this.props.product.sell_price
											&& this.props.product.sell_price.length > 0 ?
												this.props.product.sell_price.map((sell_price, sell_price_i) => {
													return (
														<option key={sell_price_i}
														        value={sell_price.id}
														>
															{sell_price.unit_name} (ราคาขายปลีก
															฿{sell_price.sell_price_1.format(2)})
														</option>)
												})
												: null
										}
										<option value="all">ทุกหน่วยนับ</option>
									</select>
								</div>
								<div className="column field required"
								     ref={(ref) => {
									     this.$priceField = window.$(ref);
									     if (this.props.mode === 'edit' && !this.props.product_price_condition.product_price_id) {
										     this.$priceField.hide();
									     }
								     }}
								>
									<label>ราคา</label>
									<div className="ui right labeled input">
										<input type="number" name="price"
										       ref={(ref) => {
											       this.$inputPrice = window.$(ref)
										       }}
										       onFocus={(event) => event.target.select()}
										       defaultValue={this.props.mode === 'edit' ?
											       this.props.product_price_condition.price :
											       this.props.product
											       && this.props.product.sell_price
											       && this.props.product.sell_price.length > 0 ?
												       this.props.product.sell_price[0].sell_price_1
												       : ''}/>
										<div className="ui basic label">บาท</div>
									</div>
								</div>

								<div className="column field required">
									<label>ส่วนลด</label>
									<div className="ui right action left input">
										<input type="text" name={"discount"}
										       onFocus={(event) => event.target.select()}
										       defaultValue={this.props.mode === 'edit' ? this.props.product_price_condition.discount : '0'}/>
										<div className="ui basic floating dropdown button"
										     ref={(ref) => {
											     window.$(ref).dropdown();
										     }}
										>
											<input type="hidden" name="discount_type"
											       defaultValue={this.props.mode === 'edit' ? this.props.product_price_condition.discount_type : "฿"}/>
											<div className="text">฿</div>
											<div className="menu">
												<div className="item"
												     data-value={'฿'}>
													฿
												</div>
												<div className="item"
												     data-value={"%"}>
													%
												</div>
											</div>
										</div>
									</div>
								</div>
								{
									this.props.mode === 'create' ?
										<div className="column field required">
											<h5 className="ui header dividing">รายชื่อ</h5>
											<div className="column inline fields">
												<label htmlFor="fruit">ประเภท:</label>
												<div className="field">
													<div className="ui radio checkbox"
													     data-form2_setup="true">
														<input type="radio"
														       name="is_relationship_group"
														       value="null"
														       defaultChecked={true}
														       tabIndex="0"
														       className="hidden"
														/>
														<label>คู่ค้าทุกคน</label>
													</div>
												</div>
												<div className="field">
													<div className="ui radio checkbox"
													     data-form2_setup="true">
														<input type="radio"
														       name="is_relationship_group"
														       value="0"
														       tabIndex="0"
														       className="hidden"
														/>
														<label>คู่ค้า</label>
													</div>
												</div>
												<div className="field">
													<div className="ui radio checkbox"
													     data-form2_setup="true">
														<input type="radio"
														       name="is_relationship_group"
														       value="1"
														       tabIndex="0"
														       className="hidden"
														/>
														<label>กลุ่มคู่ค้า</label>
													</div>
												</div>
											</div>
											<div id="relationship" className="field" style={{display: 'none'}}>
												<input type="text" name="relationship_id[]"/>
											</div>
											<div id="relationship_group" className="field" style={{display: 'none'}}>
												<input type="text" name="relationship_group_id[]"/>
											</div>
										</div>
										: null
								}
								<div className="column field">
									<div className="ui divider" style={{marginTop: 0}}/>
									{/*ประเภทการชำระเงิน*/}
									<div className="ui header" style={{margin: 0}}>
										<div className="flex row wrap middle-xs">
											<div className="ui fitted toggle checkbox" data-form2_setup="">
												<input type="checkbox" name="is_only_payment_by"/><label></label>
											</div>
											&nbsp;&nbsp;&nbsp;&nbsp;
											<h5 style={{marginTop: 0}}>เฉพาะวิธีชำระเงิน</h5>
										</div>
									</div>
									<div id="is_only_payment_by" style={{display: 'none', margin: '1rem 0 0 0'}}>
										<div>
											<input type="text"
											       name="payment_by[]"
											/>
										</div>
									</div>
									{/*credit_card_by_bangkok_bank_iplay_paygate*/}
								</div>
								<div className="column field">
									<div className="ui divider" style={{marginTop: 0}}/>
									<label>ตั้งชื่อเรียก</label>
									<input type="text" name="name"
									       defaultValue={this.props.mode === 'edit' ? this.props.product_price_condition.name : ''}/>
								</div>
								<div className="column field">
									<label>คำอธิบาย (แสดงสาธารณะ)</label>
									<textarea name="description"
									          defaultValue={this.props.mode === 'edit' ? this.props.product_price_condition.description : ''}/>
								</div>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							{
								this.props.mode === 'edit'
									? <div className="ui red button"
									       onClick={() => {
										       this.props.onDelete(this.props.product_price_condition);
									       }
									       }>ลบข้อมูล</div>
									: null
							}
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve green right button">บันทึกข้อมูล</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}

class ProductPriceConditionPermission extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			product_price_condition_permission: this.props.product_price_condition_permission || [],
		};
	}

	renderView() {
		// console.log(this.state.product_price_condition_permission);
		return (
			<span>
				{
					this.state.product_price_condition_permission
					&& this.state.product_price_condition_permission.length > 0
						?
						this.state.product_price_condition_permission.map((product_price_condition_permission, i) => {
							// console.log(product_price_condition_permission);
							if (!product_price_condition_permission) return null;

							return (
								<span
									key={product_price_condition_permission.id}
									className={"label small ui green product_price_condition_permission_label"}
									style={{marginTop: 3}}
									ref={(ref) => {
										window.$(ref).popup();
										this.$ref = window.$(ref);
									}}
									data-variation="inverted"
									data-inverted={true}
									data-content={
										product_price_condition_permission.relationship_group_id ? "กลุ่มคู่ค้า" :
											product_price_condition_permission.relationship_id ? "คู่ค้า" : 'ทุกคน'
									}>
									{
										product_price_condition_permission.relationship_group_id
											? product_price_condition_permission.relationship_group.name
											: null
									}
									{
										product_price_condition_permission.relationship_id
											? product_price_condition_permission.relationship.name
											: null
									}
									{
										!product_price_condition_permission.relationship_id
										&& !product_price_condition_permission.relationship_group_id
											? "ทุกคน"
											: null
									}
									<i className="delete icon"
									   onClick={() => {
										   window.Global.confirm({
											   title: 'ยืนยันลบข้อมูล',
											   content: '<form class="ui form">\n\t<p>โปรดยืนยันลบข้อมูล การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n\t<div class="ui error message"></div>\n</form>',
											   cancel_text: 'ไม่ดำเนินการ',
											   approve_text: 'ลบข้อมูล',
											   onShowToSetupForm: ($modal) => {
												   $modal.find('form').form2('setup');
												   $modal.find('form').form2('submit', {
													   method: 'DELETE',
													   url: process.env.REACT_APP_DOMAIN + '/api/product_price_condition_permission',
													   loadingButton: $modal.find('.button.approve'),
													   beforeSent: (data) => {
														   data = {
															   product_price_condition_permission_id: product_price_condition_permission.id,
														   };
														   return data;
													   },
													   onSuccess: () => {
														   $modal.modal('hide');
														   window.Global.messageTop({
															   type: 'positive',
															   message: 'ลบข้อมูลสำเร็จ'
														   });
														   // this.$ref.remove();

														   let new_product_price_condition_permission = [...this.state.product_price_condition_permission];
														   new_product_price_condition_permission.splice(i, 1);

														   this.setState({
															   product_price_condition_permission: new_product_price_condition_permission,
														   })
													   }
												   });
											   }
										   });

										   // this.voidProductPriceConditionpermission(
										   //    product_price_condition_permission.id,
										   //    {
										   // 	   success: () => {
										   // 		   let _product_price_condition = [...this.state.product_price_condition];
										   // 		   delete _product_price_condition[product_price_condition_i].product_price_condition_permission[product_price_condition_permission_i];
										   //
										   // 			this.setState({
										   // 			   product_price_condition: _product_price_condition
										   // 		   })
										   // 	   }
										   //    }
										   // )
									   }}
									/>
								</span>
							);
						}) : null
				}
				<span
					className={"label small ui icon"}
					style={{
						cursor: 'pointer',
						marginTop: 3
					}}
					ref={(ref) => {
						window.$(ref).popup();
					}}
					data-inverted=""
					data-variation="inverted"
					data-content={"เพิ่มรายชื่อ"}
					onClick={() => {
						window.Global.reactToDom(
							window.$('body'),
							<ProductPriceConditionPermission
								mode={"create"}
								product={this.props.product}
								product_price_condition={this.props.product_price_condition}
								CreateSuccess={() => {
									window.Global.ajax({
										method: 'GET',
										url: process.env.REACT_APP_DOMAIN + '/api/product_price_condition_permission',
										data: {
											product_price_condition_id: this.props.product_price_condition.id,
										},
										done: (response) => {
											this.setState({
												product_price_condition_permission: response.product_price_condition_permission,
											})
										}
									});
								}}
							/>
						)
					}}
				>
					<i className={"plus icon"}
					   style={{margin: 0}}
					/>
				</span>
			</span>
		)
	}

	render() {
		if (this.props.mode === 'view') {
			return this.renderView();
		}

		// console.log(this.props.product_price_condition);
		return (
			<div>
				<Modal className="ui modal tiny"
				       closable={false}
				       onShowToSetupForm={($modal) => {
					       if (this.props.mode === 'create') {
						       // $modal.find('form').form2('setup');
						       $modal.find('form').form2('setup', {
							       'is_relationship_group_onChange': (is_relationship_group) => {
								       if (is_relationship_group === '1') {
									       $modal.find('form').find('#relationship').hide();
									       $modal.find('form').find('#relationship_group').show();
									       $modal.find('form').find('input[name="relationship_id"]').explorer('clear');
									       setTimeout(() => {
										       $modal.find('form').find('div[data-explorer_input_name="relationship_group_id"] input[name="search"]').focus();
									       }, 50);
								       }
								       if (is_relationship_group === '0') {
									       $modal.find('form').find('#relationship').show();
									       $modal.find('form').find('#relationship_group').hide();
									       $modal.find('form').find('input[name="relationship_group_id"]').explorer('clear');
									       setTimeout(() => {
										       $modal.find('form').find('div[data-explorer_input_name="relationship_id"] input[name="search"]').focus();
									       }, 50);
								       }
								       if (is_relationship_group === 'null') {
									       $modal.find('form').find('#relationship').hide();
									       $modal.find('form').find('#relationship_group').hide();

									       $modal.find('form').find('input[name="relationship_id"]').explorer('clear');
									       $modal.find('form').find('input[name="relationship_group_id"]').explorer('clear');
								       }
							       }
						       });

						       $modal.find('form').find('input[name="relationship_id"]').explorer({
							       url: process.env.REACT_APP_DOMAIN + '/api/relationship',
							       additionalData: {
								       limit: 30,
								       page: 1
							       },
							       key: 'relationship',
							       template: {
								       list: function (product) {
									       return window.Handlebars.compile('<div class="item">\n\t<div class="flex row">\n\t\t<div>\n\t\t\t<b>{{name}}</b>\n\t\t</div>\n\t</div>\n</div>')(product);
								       },
								       selected: {
									       text: 'name',
									       value: 'id',
									       placeholder: 'เลือกคู่ค้า'
								       }
							       }
						       });

						       $modal.find('form').find('input[name="relationship_group_id"]').explorer({
							       url: process.env.REACT_APP_DOMAIN + '/api/relationship/group',
							       additionalData: {
								       limit: 30,
								       page: 1
							       },
							       key: 'relationship_group',
							       template: {
								       list: function (relationship_group) {
									       return window.Handlebars.compile('<div class="item">\n\t<div class="flex row">\n\t\t<div>\n\t\t\t<b>{{name}}</b>\n\t\t</div>\n\t</div>\n</div>')(relationship_group);
								       },
								       selected: {
									       text: 'name',
									       value: 'id',
									       placeholder: 'เลือกกลุ่มคู่ค้า'
								       }
							       }
						       });

						       $modal.find('form').form2('submit', {
							       method: 'POST',
							       url: process.env.REACT_APP_DOMAIN + '/api/product_price_condition_permission',
							       beforeSent: (object) => {
								       if (parseFloat(object.is_relationship_group)) {
									       delete object.relationship_id;
								       }
								       if (!parseFloat(object.is_relationship_group)
									       && parseFloat(object.is_relationship_group) !== undefined) {
									       delete object.relationship_group_id;
								       }
								       if (!parseFloat(object.is_relationship_group)
									       && parseFloat(object.is_relationship_group) === undefined) {
									       delete object.relationship_group_id;
									       delete object.relationship_id;
								       }
								       return object;
							       },
							       loadingButton: $modal.find('.button.approve'),
							       onSuccess: (response) => {
								       $modal.modal('hide');
								       window.Global.messageTop({
									       type: 'positive',
									       message: 'บันทึกข้อมูลเรียบร้อย'
								       });

								       this.props.CreateSuccess(response);
							       }
						       });
					       }

				       }}>
					<div className="header">
						<h2>
							เพิ่มรายชื่อ
						</h2>
					</div>
					<div className="content">
						<form className="ui form">
							{
								this.props.mode === 'create' ?
									<>
										<input type="hidden"
										       name="product_price_condition_id"
										       defaultValue={this.props.product_price_condition.id}/>
										<input type="hidden"
										       name="is_allow"
										       defaultValue={"1"}/>
									</>
									: null
							}

							<div className="flex row wrap column one column computer padded">

								{
									this.props.mode === 'create' ?
										<div className="column field required">
											<div className="column inline fields">
												<label htmlFor="fruit">ประเภท:</label>
												<div className="field">
													<div className="ui radio checkbox"
													     data-form2_setup="true">
														<input type="radio"
														       name="is_relationship_group"
														       value="0"
														       defaultChecked={true}
														       tabIndex="0"
														       className="hidden"
														/>
														<label>คู่ค้า</label>
													</div>
												</div>
												<div className="field">
													<div className="ui radio checkbox"
													     data-form2_setup="true">
														<input type="radio"
														       name="is_relationship_group"
														       value="1"
														       tabIndex="0"
														       className="hidden"
														/>
														<label>กลุ่มคู่ค้า</label>
													</div>
												</div>
												<div className="field">
													<div className="ui radio checkbox"
													     data-form2_setup="true">
														<input type="radio"
														       name="is_relationship_group"
														       value="null"
														       tabIndex="0"
														       className="hidden"
														/>
														<label>คู่ค้าทุกคน</label>
													</div>
												</div>
											</div>
											<div id="relationship" className="field">
												<input type="text" name="relationship_id"/>
											</div>
											<div id="relationship_group" className="field" style={{display: 'none'}}>
												<input type="text" name="relationship_group_id"/>
											</div>
										</div>
										: null
								}
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							{
								this.props.mode === 'edit'
									? <div className="ui red button"
									       onClick={() => {
										       this.props.onDelete(this.props.product_price_condition);
									       }
									       }>ลบข้อมูล</div>
									: null
							}
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve green right button">บันทึกข้อมูล</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}

class ProducUomItem extends React.Component {
	constructor() {
		super();
		this.state = {
			is_delete: 0
		}
	}

	render() {
		return (
			<div className="ui form flex ProductSellPrice_list"
			     style={this.props.index === 0 ? {borderTopWidth: 0, paddingTop: 0} : null}>
				<div className="four fields flex row"
				     style={{marginBottom: '0.7em', alignItems: 'flex-end'}}>
					{
						this.props.mode === 'edit' ?
							<>
								<input type="hidden" name="sell_price[][product_price_id]"
								       value={this.props.sell_price.id}/>
								<input type="hidden" name="sell_price[][product_id]"
								       value={this.props.sell_price.product_id}/>
							</>
							: null
					}
					<input type="hidden" name="sell_price[][is_delete]"
					       value={this.state.is_delete}/>
					<div className="field">
						<label>หน่วยนับ</label>
						<input type="text"
						       name="sell_price[][unit_name]"
						       defaultValue={this.props.mode === 'edit' && this.props.sell_price ? this.props.sell_price.unit_name : ''}
						       placeholder=""/>
					</div>
					<div className="field">
						<label>จำนวน (อัตราส่วน)</label>
						<input type="text"
						       name="sell_price[][ratio]"
						       placeholder="อัตราส่วน"
						       defaultValue={this.props.mode === 'edit' && this.props.sell_price ? this.props.sell_price.ratio : ''}
						       readOnly="readonly"/>
					</div>
					<div className="field">
						<label>ราคาขายปลีก</label>
						<input type="text"
						       name="sell_price[][sell_price_1]"
						       placeholder="บาท"
						       className="ProductListUom_inputPrice1"
						       defaultValue={this.props.mode === 'edit' && this.props.sell_price ? this.props.sell_price.sell_price_1 : ''}/>
					</div>
					<div className="field">
						<label>ราคาขายส่ง</label>
						<input type="text"
						       name="sell_price[][sell_price_2]"
						       placeholder="บาท"
						       className="ProductListUom_inputPrice2"
						       defaultValue={this.props.mode === 'edit' && this.props.sell_price ? this.props.sell_price.sell_price_2 : ''}/>
					</div>
				</div>
				<div className="four fields flex row"
				     style={{marginBottom: '0.7em', alignItems: 'flex-end'}}>
					<div className="field"><label>&nbsp;</label></div>
					<div className="field"><label>&nbsp;</label></div>
					<div className="field">
						<label>ราคาซื้อ</label>
						<input type="text" name="sell_price[][buy_price_1]"
						       placeholder="บาท"
						       className="ProductListUom_inputPrice1"
						       defaultValue={this.props.mode === 'edit' && this.props.sell_price ? this.props.sell_price.buy_price_1 : ''}/>
					</div>
					<div className="field"><label>&nbsp;</label></div>

				</div>
			</div>
		);
	}
}

class ProductInitialStock extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			product: props.product,
			stock: [],
			current_branch: false,
			is_loading: false,
		}
	}

	componentDidMount() {
		let data = {...this.state.product};
		data.initial_stock_on_hand = parseFloat(this.state.product.initial_stock_on_hand);
		data.initial_cost_price_per_unit = parseFloat(this.state.product.initial_cost_price_per_unit);
		this.$modal.find('form').form2('setup');
		this.$modal.find('form').form2('init', {
			data: data,
		});
		this.$modal.find('#initial_stock_on_hand_dropdown').dropdown({
			onChange: (value) => {
				this.setStockInHand()
			}
		})
	}

	setStockInHand() {
		let initial_stock_on_hand = this.$modal.find('form').find('[name="initial_stock_on_hand2"]').val();
		let ratio = this.$modal.find('form').find('#initial_stock_on_hand_dropdown').dropdown('get value');
		if (!ratio || ratio === '') {
			ratio = this.state.product.sell_price[0].ratio;
		}
		let stock_on_hand = parseFloat(initial_stock_on_hand) * parseFloat(ratio);
		this.$modal.find('form').find('input[name="initial_stock_on_hand"]').val(stock_on_hand)
	}

	render() {
		// console.log(this.state.product);
		return (
			<div>
				<Modal className="ui modal tiny"
				       closable={false}
				       onShowToSetupForm={($modal) => {
					       this.$modal = $modal;
					       $modal.find('form').form2('submit', {
						       method: 'PUT',
						       url: process.env.REACT_APP_DOMAIN + '/api/v1/product/initial-stock',
						       loadingButton: $modal.find('.button.approve'),
						       beforeSent: (data) => {
							       delete data.initial_stock_on_hand2;
							       // console.log(data)
							       //    return;
							       return data;
						       },
						       onSuccess: (response) => {
							       $modal.modal('hide');
							       window.Global.messageTop({
								       type: 'positive',
								       message: 'แก้ไขข้อมูลสำเร็จ'
							       });
							       window.location.reload();
							       // if (this.props.onSuccess) {
							       //     this.props.onSuccess(response);
							       // }
							       //this.props.onEditedSuccess(response);
							       // this.setState({
							       //    product_display: {...response.product_display}
							       // });
						       }
					       });
				       }}
				>
					<div className="header">
						<h2>
							{this.props.mode === 'edit' ? 'แก้ไข' : null}
							{this.props.mode === 'create' ? 'เพิ่ม' : null}
							ยอดยกมา (จำนวนสินค้าจากระบบเดิม)
						</h2>
					</div>
					<div className="content">
						<form className={"ui form"}>
							{
								this.state.is_loading ?
									<div className="ui active inverted dimmer">
										<div className="ui text loader">
											{/*Loading*/}
										</div>
									</div>
									:
									null
							}
							<div className="two fields">
								<div className="field">
									<label>จำนวนสินค้าที่ยกมา</label>
									<div className="ui right labeled input">
										<input type={"hidden"} name={"product_id"}
										       defaultValue={this.state.product.id}/>
										<input type="number" placeholder="จำนวน"
										       name="initial_stock_on_hand2"
										       defaultValue={parseFloat(this.state.product.initial_stock_on_hand)}
										       onChange={(e) => {
											       this.setStockInHand()
										       }}
										/>
										<input type="hidden"
										       name="initial_stock_on_hand"
										       className="ui dropdown label"
										       defaultValue={parseFloat(this.state.product.initial_stock_on_hand)}
										/>

										<div id="initial_stock_on_hand_dropdown"
										     className="ui dropdown label"
										     data-name="initial_stock_on_hand_dropdown"
										     tabIndex="0"
										>
											<div className="text">
												{Helper.getRatioUnitByOrder(this.state.product.sell_price, {return_sell_price: 'min'}).unit_name}
											</div>
											<i className="dropdown icon"/>
											<div className="menu transition hidden"
											     tabIndex="-1">
												{
													this.state.product.sell_price.map((_sell_price, _sell_price_i) => (
														<div className="item"
														     key={_sell_price_i}
														     data-value={_sell_price.ratio}>
															{_sell_price.unit_name}
														</div>
													))
												}
											</div>
										</div>
									</div>
								</div>
								<div className="field">
									<label>ราคาทุนต่อหน่วย</label>
									<div className="ui right labeled input">
										<input type="number"
										       placeholder="ราคา"
										       name="initial_cost_price_per_unit"
										       data-clean-number=""
										       data-decimal="true"
										       defaultValue={parseFloat(this.state.product.initial_cost_price_per_unit)}
										/>
										<div className="ui label">฿</div>
									</div>
								</div>
							</div>
							<div className="two fields">
								<div className="field">
									<label>กำหนดคลังสินค้าของสินค้าที่ยกมา</label>
									{
										this.state.product.initial_stock_location
											? <p>{this.state.product.initial_stock_location.name}</p>
											:
											<input
												ref={(ref) => {
													if (!ref) return;
													window.$(ref).explorer({
														url: process.env.REACT_APP_DOMAIN + '/api/stock',
														additionalData: {
															limit: 5,
															page: 1
														},
														key: 'stock',
														template: {
															list: '<a class="item flex row">{{name}}</a>',
															selected: {
																text: 'name',
																value: 'id',
																placeholder: 'เลือกคลัง'
															}
														}
													});
												}}
												name="initial_stock_location_id"
											/>
									}
								</div>
								<div className="field">
									<label>วันที่ที่ยกมา</label>
									<div data-form_calendar="date"
									     data-input_name="initial_stock_date"
									     data-placeholder={"วันที่ที่ยกมา"}
									     data-locale="th"
									/>
								</div>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve green right button">บันทึกข้อมูล</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}

class UploadReport extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			is_loading: false,
		}
	}


	render() {
		// console.log(this.state.product);
		return (
			<div>
				<Modal className="ui modal tiny"
				       closable={false}
				       onShowToSetupForm={($modal) => {
					       this.$modal = $modal;
					       $modal.find('form').form2('setup');
					       $modal.find('form').form2('submit', {
						       method: 'PUT',
						       url: process.env.REACT_APP_DOMAIN + '/api/v1/product/initial-stock',
						       loadingButton: $modal.find('.button.approve'),
						       beforeSent: (data) => {
							       console.log(data);
							       return;
							       // return data;
						       },
						       onSuccess: (response) => {
							       $modal.modal('hide');
							       window.Global.messageTop({
								       type: 'positive',
								       message: 'แก้ไขข้อมูลสำเร็จ'
							       });
							       if (this.props.onSuccess) {
								       this.props.onSuccess(response);
							       }
							       //this.props.onEditedSuccess(response);
							       // this.setState({
							       //    product_display: {...response.product_display}
							       // });
						       }
					       });
				       }}
				>
					<div className="header">
						<h2>
							อัพโหลดเอกสาร
						</h2>
					</div>
					<div className="content">
						<form className={"ui form"}>
							{
								this.state.is_loading ?
									<div className="ui active inverted dimmer">
										<div className="ui text loader">
											{/*Loading*/}
										</div>
									</div>
									:
									null
							}
							{
								!this.state.is_loading ?
									<>
										<div className="field">
											<p style={{color: 'green'}}><strong>กรณีสร้าง </strong>ใช้ template
												เดิมไปก่อน</p>
										</div>
										<div className="field">
											<p style={{color: 'red'}}><strong>กรณีแก้ไข </strong>ใช้ template
												จากการดาวน์โหลดหน้ารายการสินค้า<br/>
												Column ที่ไม่สามารถแก้ไขได้<br/>
												- สินค้ามี Serial Number<br/>
												- ไม่นับสต๊อก (บริการ)<br/>
												- สัญญารายเดือน<br/>
												- ยอดยกมา<br/>
												- เข้าคลังสินค้า
											</p>
										</div>
										<div className={"field"}>
											<label>อัพโหลด</label>
											<Form2FileUpload
												upload_type="upload"
												input_name="image_filename"
												key_file_data="file_upload"
												url={process.env.REACT_APP_DOMAIN + '/api/file/upload?type=upload'}
												// onImageUploadSuccess={(file) => {
												//
												// }}
												// onRemove={() => {
												//
												// }}
											/>
										</div>
										<div className="field">
											<div className="ui checkbox"
											     ref={(ref) => window.$(ref).checkbox()}
											>
												<input type="checkbox" tabIndex="0" className="hidden" name={"is_"}
												       id={"checkbox"}/>
												<label htmlFor={"checkbox"}>แก้ไข (ยึดตามรหัสสินค้า)</label>
											</div>
										</div>
									</>
									: null
							}
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve green right button">ตกลง</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}

export const ProductBomAdjustmentCost = {
	fetch: function (product) {
		var $parent = window.$('#Product_viewRoot');

		var $tbody = $parent.find('#product_bom_adjustment_cost tbody');
		// Sell price discount
		$parent.find('#product_bom_adjustment_cost .button').off('click').on('click', function () {
			ProductBomAdjustmentCost.manage(product);
		});

		window.$.each(product['product_bom_adjustment_cost'], function (i, product_bom_adjustment_cost) {
			var $e = window.$(window.Handlebars.compile('<tr>\n\t<td>{{cost_product.name}} <span class="ui label edit">แก้ไข</span></td>\n\t<td>{{cost_product_quantity2}}</td>\n</tr>')(product_bom_adjustment_cost));
			$tbody.prepend($e);

			$e.on('click', function () {
				ProductBomAdjustmentCost.manage(product, product_bom_adjustment_cost);
			});
		});
	},
	manage: function (product, product_bom_adjustment_cost, options) {
		var $parent = window.$(window.Handlebars.compile(window.$('#template-product_bom_adjustment_cost').html())(product));
		var $form = $parent.find('.ui.form');
		$form.form2('init');

		var $e = window.GlobalFunc.setupQuantityAndRatio($parent.find('#unitPriceDropdown'), {
			product: product,
			input_ratio: 'material_ratio',
			quantityReadOnly: true
		});
		window.GlobalFunc.setQuantityUnitName($parent, {
			$quantity: $e.find('input[name="user_input_quantity"]'),
			quantity: !product_bom_adjustment_cost
				? product.sell_price[0].ratio
				: product_bom_adjustment_cost.material_ratio,
			ratio: !product_bom_adjustment_cost
				? product.sell_price[0].ratio
				: product_bom_adjustment_cost.material_ratio,
			$unit_name_dropdown: $e.find('.Item_selectUnitName'),
			product: product
		});

		$form.find('input[name="cost_product_id"]').explorer({
			url: window.GlobalFunc.getUrl('/api/product'),
			additionalData: {
				limit: 5,
				page: 1
			},
			key: 'product',
			template: {
				list: '<a class="item flex row">{{name}}</a>',
				selected: {
					text: 'name',
					value: 'id',
					placeholder: 'เลือกสินค้าต้นทุน'
				}
			},
			onSelected: function (product) {
				var $e = window.GlobalFunc.setupQuantityAndRatio($parent.find('#unitPriceDropdown2'), {
					product: product,
					input_ratio: 'cost_ratio',
					quantityReadOnly: true
				});
				$e.find('.Item_selectUnitName').dropdown('set selected', '0');

				window.GlobalFunc.setQuantityUnitName($parent, {
					$quantity: $e.find('input[name="user_input_quantity"]'),
					quantity: product_bom_adjustment_cost
						? product_bom_adjustment_cost.cost_ratio
						: product.sell_price[0].ratio,
					ratio: product_bom_adjustment_cost
						? product_bom_adjustment_cost.cost_ratio
						: product.sell_price[0].ratio,
					$unit_name_dropdown: $e.find('.Item_selectUnitName'),
					product: product
				});
			}
		});

		$form.find('input[name="cost_product_id"]')
			.explorer('set disable unselected');

		if (!product_bom_adjustment_cost) {
			// new
			$form.form2('submit', {
				method: 'POST',
				url: window.GlobalFunc.getUrl('/api/product/bom_adjustment_cost'),
				beforeSent: function (object) {
					object.product_id = product.id;
					return object;
				},
				submitButton: $parent.find('.button.approve'),
				loadingButton: $parent.find('.button.approve'),
				onSuccess: function (response) {
					window.Global.messageTop({
						type: 'positive',
						message: 'บันทึกข้อมูลเรียบร้อย'
					});
					// ProductBomAdjustmentCost.fetch(response.product);
					// $parent.modal('hide');
					window.location.reload();
				}
			});
		} else {
			// edit
			$form.form2('init', {
				data: product_bom_adjustment_cost
			});

			$form.find('input[name="cost_product_id"]')
				.explorer('set value', product_bom_adjustment_cost.cost_product)
				.explorer('set disable unselected');

			$form.form2('submit', {
				method: 'PUT',
				url: window.GlobalFunc.getUrl('/api/product/bom_adjustment_cost'),
				beforeSent: function (object) {
					object.product_bom_adjustment_cost_id = product_bom_adjustment_cost.id;
					return object;
				},
				submitButton: $parent.find('.button.approve'),
				loadingButton: $parent.find('.button.approve'),
				onSuccess: function (response) {
					window.Global.messageTop({
						type: 'positive',
						message: 'บันทึกข้อมูลเรียบร้อย'
					});
					window.location.reload();
				}
			});

			$parent.find('.red.button').on('click', function () {
				window.Global.confirm({
					title: 'ยืนยันการลบ',
					content: 'โปรดยืนยันลบ การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้',
					cancel_text: 'ยกเลิก',
					approve_text: 'ลบ',
					onApprove: function ($modal) {
						var $button = $modal.find('.approve.button');
						$button.addClass('loading');
						window.Global.ajax({
							method: 'DELETE',
							url: window.GlobalFunc.getUrl('/api/product/bom_adjustment_cost'),
							data: {product_bom_adjustment_cost_id: product_bom_adjustment_cost.id},
							done: function (response) {
								$button.removeClass('loading');
								if (response.error && response['message']) {
									window.Global.messageTop({
										type: 'negative',
										message: response['message'][0]['error_message']
									});
									return;
								}
								if (!response.success) return;
								window.Global.messageTop({
									type: 'positive',
									message: 'ลบข้อมูลเรียบร้อย'
								});
								window.location.reload();
							}
						});
						return false;
					}
				});
			}).show();
		}

		$parent.modal({
			autofocus: false,
			onApprove: function () {
				return false;
			}
		}).modal('show');
	}
};
export const Product = {
	manageProductSellPriceDiscount: function (product, product_price_condition, options) {
		if (!options) {
			options = {};
		}

		var $parent = window.$(window.$('#template-manage-product-sell-price-discount').html());
		var $form = $parent.find('.ui.form');
		$form.form2('init');

		var $e2 = $parent.find('#unitPriceDropdown2');

		// create dropdown select unit name
		var $e = window.$(window.Mustache.render('<div class="Table_column flex row center align span2 half">\n\t<div class="ui right action left input" style="width: 100%;">\n\t\t<input type="text" name="product_price_condition_stair_step[begin__quantity]" placeholder="à¸ˆà¸³à¸™à¸§à¸™" value="1">\n\t\t<div class="ui basic floating dropdown button Item_selectUnitName">\n\t\t\t<div class="text">-</div>\n\t\t\t<div class="menu"></div>\n\t\t</div>\n\t\t<input type="hidden" name="ratio" value="1">\n\t\t<input type="hidden" name="product_price_condition_stair_step[begin_quantity]">\n\t</div>\n</div>', product));
		$parent.find('#unitPriceDropdown').empty().html($e);
		window.$.each(product.sell_price, function (i2, value2) {
			value2.index = i2;
			$e.find('.menu').append(window.Mustache.render('<div data-value="{{index}}" data-index="{{index}}" data-ratio="{{ratio}}" data-sell_price_1="{{sell_price_1}}" class="item">{{unit_name}}</div>', value2));
		});

		var $begin__quantity = $parent.find('input[name="product_price_condition_stair_step[begin__quantity]"]');
		var $begin_quantity = $parent.find('input[name="product_price_condition_stair_step[begin_quantity]"]');
		var $maximum__quantity = $parent.find('input[name="product_price_condition_stair_step[maximum__quantity]"]');
		var $maximum_quantity = $parent.find('input[name="product_price_condition_stair_step[maximum_quantity]"]');

		$e.find('.Item_selectUnitName').dropdown({
			onChange: function (value2, text2, $choice) {
				// console.log(value, text, $choice);
				var data = $choice.data();
				$e.find('input[name="ratio"]').val(parseFloat(data.ratio));
				$parent.find('input[name="price"]').val(parseFloat(data.sell_price_1));
				$begin__quantity.trigger('focusout');

				$e2.find('.text').text(text2);
			}
		});

		$parent.find('.Item_selectUnitNameDiscount').dropdown({
			onChange: function (discount_type) {
				$parent.find('input[name="discount_type"]').val(discount_type);
			}
		});

		function onChange() {
			var ratio = parseFloat($e.find('input[name="ratio"]').val());

			// // begin_quantity
			// var begin__quantity = parseFloat($begin__quantity.val());
			// if (isNaN(begin__quantity)) begin__quantity = 1;
			// $begin__quantity.val(begin__quantity);
			// var begin_quantity = begin__quantity * ratio;
			// $begin_quantity.val(begin_quantity);

			let begin__quantity = $begin__quantity.cleanNumber({
				decimal: true,
			});
			let begin_quantity = begin__quantity * ratio;
			$begin_quantity.val(begin_quantity);

			// // maximum_quantity
			// var maximum__quantity = parseFloat($maximum__quantity.val());
			// if (isNaN(maximum__quantity)) maximum__quantity = 1;
			// $maximum__quantity.val(maximum__quantity);
			// var maximum_quantity = maximum__quantity * ratio;
			// $maximum_quantity.val(maximum_quantity);

			let maximum__quantity = $maximum__quantity.cleanNumber({
				decimal: true,
			});
			let maximum_quantity = maximum__quantity * ratio;
			$maximum_quantity.val(maximum_quantity);

			if (begin_quantity > maximum_quantity) {
				$maximum__quantity.val(begin__quantity);
				$maximum__quantity.trigger('focusout');
			}

			// price
			var $price = $parent.find('input[name="price"]');
			var price = parseFloat($price.val());
			if (isNaN(price)) {
				$price.val('0');
			} else {
				$price.val(price);
			}
		}

		$parent.find('input[name="product_price_condition_stair_step[begin__quantity]"]').on('keyup', function () {
			console.log('keyup');
			onChange();
		}).on('focusout', function () {
			window.$(this).trigger('keyup');
		}).on('focus', function () {
			window.$(this).select();
		});

		$parent.find('input[name="product_price_condition_stair_step[maximum__quantity]"]').on('focusout', function () {
			console.log('focusout');
			onChange();
		}).on('focus', function () {
			window.$(this).select();
		});

		$parent.find('input[name="discount"]').on('focusout', function () {
			console.log('focusout');
			var discount = parseFloat(window.$(this).val());
			if (isNaN(discount)) {
				window.$(this).val('0');
			} else {
				window.$(this).val(discount);
			}
		}).on('focus', function () {
			window.$(this).select();
		});

		$parent.find('input[name="price"]').on('focus', function () {
			window.$(this).select();
		});

		if (!product_price_condition) {
			// new
			$e.find('.Item_selectUnitName').dropdown('set selected', '0');
			$form.form2('submit', {
				method: 'POST',
				url: window.GlobalFunc.getUrl('/api/product_price_condition'),
				beforeSent: function (object) {
					object.type = 'stair_step';
					object.product_id = product.id;
					return object;
				},
				submitButton: $parent.find('.button.approve'),
				loadingButton: $parent.find('.button.approve'),
				onSuccess: function (response) {
					window.Global.messageTop({
						type: 'positive',
						message: 'บันทึกข้อมูลเรียบร้อย'
					});
					$parent.modal('hide');

					if (options.onCreated) {
						options.onCreated(response);
					} else {
						window.location.reload();
					}
				}
			});
		} else {
			// edit
			$begin__quantity.val(product_price_condition['product_price_condition_stair_step'].begin__quantity);
			$maximum__quantity.val(product_price_condition['product_price_condition_stair_step'].maximum__quantity);
			setTimeout(function () {
				window.$.each(product['sell_price'], function (i, product_price) {
					if (product_price.id === product_price_condition.product_price_id) {
						$e.find('.Item_selectUnitName').dropdown('set selected', i + '');
					}
				});
				$form.find('.Item_selectUnitNameDiscount').dropdown(
					'set selected',
					product_price_condition.discount_type + ''
				);

				product_price_condition.price = parseFloat(product_price_condition.price);
				$form.form2('init', {
					data: product_price_condition
				});
			}, 500);

			$form.form2('submit', {
				method: 'PUT',
				url: window.GlobalFunc.getUrl('/api/product_price_condition'),
				beforeSent: function (object) {
					object.product_price_condition_id = product_price_condition.id;
					object.product_id = product_price_condition.product_id;
					object.type = 'stair_step';
					return object;
				},
				submitButton: $parent.find('.button.approve'),
				loadingButton: $parent.find('.button.approve'),
				onSuccess: function (response) {
					window.Global.messageTop({
						type: 'positive',
						message: 'บันทึกข้อมูลเรียบร้อย'
					});
					$parent.modal('hide');

					if (options.onEdited) {
						options.onEdited(response);
					} else {
						window.location.reload();
					}
				}
			});

			$parent.find('.red.button').on('click', function () {
				window.Global.confirm({
					title: 'ยืนยันการลบ',
					content: 'โปรดยืนยันลบ การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้',
					cancel_text: 'ยกเลิก',
					approve_text: 'ลบ',
					onApprove: function ($modal) {
						var $button = $modal.find('.approve.button');
						$button.addClass('loading');
						window.Global.ajax({
							method: 'DELETE',
							url: window.GlobalFunc.getUrl('/api/product_price_condition'),
							data: {
								product_price_condition_id: product_price_condition['id']
							},
							done: function (response) {
								$button.removeClass('loading');
								if (response.error && response['message']) {
									window.Global.messageTop({
										type: 'negative',
										message: response['message'][0]['error_message']
									});
									return;
								}
								if (!response.success) return;

								window.Global.messageTop({
									type: 'positive',
									message: 'ลบข้อมูลเรียบร้อย'
								});
								$modal.modal('hide');
								setTimeout(function () {
									$modal.remove();
								}, 5000);

								if (options.onDeleted) {
									options.onDeleted(response);
								} else {
									window.location.reload();
								}
							}
						});
						return false;
					}
				});
			}).show();
		}

		$parent.modal({
			autofocus: false,
			closable: false,
			onApprove: function () {
				return false;
			}
		}).modal('show');
	},
	onDoneEditUom: function () {
		var $Product_editRoot = window.$('#Product_editRoot');
		var $form = $Product_editRoot.find('.ui.form');
		var $ProductListUom_root = window.$('.ProductListUom_root');

		var old1 = $form.find('*[name="default_buy_unit_type_index"]').val();
		var old2 = $form.find('*[name="default_sell_unit_type_index"]').val();

		var $option = window.$(window.Mustache.render('<option value="null">ไม่ระบุ</option>'));
		var $option2 = window.$(window.Mustache.render('<option value="null">ไม่ระบุ</option>'));
		$form.find('*[name="default_buy_unit_type_index"]').empty().append($option);
		$form.find('*[name="default_sell_unit_type_index"]').empty().append($option2);
		$form.find('#initial_stock_on_hand_dropdown .menu').empty();

		$ProductListUom_root.find('.ProductSellPrice_list').each(function (i) {
			var name = window.$(this).find('*[name="sell_price[][unit_name]"]').val();
			if (name === '') return;
			var value = {
				index: i,
				name: name,
				selected:
					old1 === ''
					|| parseInt(old1) === i
						? 'selected="selected"'
						: ''
			};
			var $option = window.$(window.Mustache.render('<option value="{{index}}" {{{selected}}}>{{name}}</option>', value));
			value.selected = old2 === ''
			|| parseInt(old2) === i
				? 'selected="selected"'
				: '';
			var $option2 = window.$(window.Mustache.render('<option value="{{index}}" {{{selected}}}>{{name}}</option>', value));
			var $option3 = window.$(window.Mustache.render('<div class="item" data-value="{{index}}">{{name}}</div>', value));
			$form.find('*[name="default_buy_unit_type_index"]').append($option);
			$form.find('*[name="default_sell_unit_type_index"]').append($option2);
			$form.find('#initial_stock_on_hand_dropdown .menu').append($option3);
		});
		$form.find('*[name="default_buy_unit_type_index"]')
			.dropdown('refresh')
			.dropdown('set text', 'ไม่เลือก');
		$form.find('*[name="default_sell_unit_type_index"]')
			.dropdown('refresh')
			.dropdown('set text', 'ไม่เลือก');
		$form.find('#initial_stock_on_hand_dropdown')
			.dropdown('refresh')
			.dropdown('set selected', '0');

		$ProductListUom_root.find('div[data-nodata]').remove();
		if ($ProductListUom_root.find('.ProductSellPrice_list').length === 0) {
			$ProductListUom_root.append('<div data-nodata style="padding: 1.5rem;opacity: 0.6;text-align: center;">ไม่ได้กำหนดหน่วยนับ</div>')
		}

		$form.find('input[name="initial_stock_on_hand2"]').trigger('keyup');
	},
}
